<template>
  <div>
    <!-- Header Start -->
    <header class="">
      <div class="logo-center">
        <router-link to="/" class="logo-link">
          <img
            class="logo logo-light"
            src="/assets/images/logos/logo-w.webp"
            alt="logo"
          />
        </router-link>
      </div>
    </header>
    <!-- Header End -->
    <!-- Main End -->
    <section class="form-checkout" :style="{ display: !loader ? '' : 'none' }">
      <div class="progress-bar">
        <!-- :class="{'active': !loggedIn}" -->
        <div class="progress" id="progress"></div>
        <div class="progress-step active">
          <h6>1</h6>
          <p>Cuenta</p>
        </div>
        <!-- loggedIn -->
        <div class="progress-step" :class="{ active: type_nav >= 2 }">
          <h6>2</h6>
          <p>Información</p>
        </div>
        <div
          class="progress-step"
          data-title="Contact "
          :class="{ active: type_nav >= 3 }"
        >
          <h6>3</h6>
          <p>Entrega</p>
        </div>
        <div
          class="progress-step"
          data-title="Experiences"
          :class="{ active: type_nav >= 4 }"
        >
          <h6>4</h6>
          <p>Pago</p>
        </div>
      </div>
      <form method="post" class="form">
        <!-- Progress Bar -->

        <!-- Steps !loggedIn-->

        <div class="form-step" :class="{ active: type_nav == 1 }">
          <ul class="tab-menu" id="tab-menu3">
            <li>
              <a
                @click.prevent="activeTab = 'login'"
                :class="{ active: activeTab === 'login' }"
              >
                <img src="/assets/images/checkout/User Check.svg" alt="" />
                Iniciar sesión</a
              >
            </li>
            <li>
              <a
                @click.prevent="activeTab = 'register'"
                :class="{ active: activeTab === 'register' }"
              >
                <img src="/assets/images/checkout/User Plus.svg" alt="" /> Crear
                cuenta</a
              >
            </li>
            <li>
              <a
                @click.prevent="activeTab = 'guest'"
                :class="{ active: activeTab === 'guest' }"
              >
                <img src="/assets/images/checkout/User Cross.svg" alt="" /> Modo
                invitado</a
              >
            </li>
          </ul>

          <div
            v-show="activeTab === 'login'"
            class="tab-content"
            :class="{ active: activeTab === 'login' }"
          >
            <p class="subtitle">
              Si ya posees una cuenta, por favor ingresa tu correo electrónico y
              contraseña
            </p>
            <div class="input-group">
              <label>Correo electrónico</label>
              <input
                type="email"
                v-model="email_login"
                @input="sanitizeField($event, 'email_login')"
              />
            </div>

            <div class="input-group">
              <label for="phone">Contraseña</label>
              <input
                type="password"
                v-model="password_login"
                @input="sanitizeField($event, 'password_login')"
              />
            </div>

            <div class="btn-sesion">
              <div class="loader-5 center" v-if="loading"><span></span></div>
              <a class="btn" @click="Login()" v-if="!loading">Iniciar sesión</a>
            </div>
          </div>

          <div
            v-show="activeTab === 'register'"
            class="tab-content"
            :class="{ active: activeTab === 'register' }"
          >
            <div v-if="!showOtpInput">
              <p class="subtitle">
                Tomate un minuto para crear tu cuenta y disfrutar de muchos
                beneficios
              </p>
              <div class="input-group">
                <label>Nombres</label>
                <input
                  type="text"
                  v-model="name_register"
                  @input="onlyStringVarcharN"
                />
              </div>
              <div class="input-group">
                <label>Apellidos</label>
                <input
                  type="text"
                  v-model="surname_register"
                  @input="onlyStringVarcharS"
                />
              </div>
              <div class="input-group">
                <label>Correo electrónico</label>
                <input
                  type="email"
                  v-model="email_register"
                  @keypress="allowEmailKeypress"
                  @paste.prevent="handleEmailPaste"
                  @input="sanitizeEmailOnInput"
                />
              </div>
              <div class="input-group">
                <label>Contraseña</label>
                <input type="password" v-model="password_register" />
              </div>
              <div class="btn-sesion">
                <div class="loader-5 center" v-if="loading"><span></span></div>
                <a class="btn" @click="Register()" v-if="!loading"
                  >Registrarme</a
                >
              </div>
            </div>

            <div v-if="showOtpInput">
              <p class="subtitle">
                Ingresa el código de 6 dígitos que te enviamos a
                <span style="font-weight: bold">{{ email_register }}</span
                >.
              </p>
              <div
                class="otp-container"
                style="
                  display: flex;
                  gap: 10px;
                  justify-content: center;
                  margin: 20px 0;
                "
              >
                <input
                  v-for="(digit, index) in 6"
                  :key="index"
                  type="number"
                  maxlength="1"
                  ref="otpRefs"
                  style="
                    width: 40px;
                    height: 50px;
                    text-align: center;
                    font-size: 1.5rem;
                    border: 1px solid #ccc;
                    border-radius: 5px;
                  "
                  @input="handleOtpInput($event, index)"
                  @keydown.backspace="handleOtpBackspace($event, index)"
                  @paste="handleOtpPaste"
                />
              </div>
              <div class="btn-sesion" v-if="loading">
                <div class="loader-5 center"><span></span></div>
              </div>
              <div
                class="container-btn"
                style="text-align: center; margin-top: 20px"
              >
                <button
                  class="btn-resend"
                  style="
                    background: none;
                    border: none;
                    color: #0da487;
                    cursor: pointer;
                  "
                  :disabled="isResendDisabled"
                  @click="resendCode"
                >
                  Reenviar código
                  <span v-if="isResendDisabled">({{ formattedTime }})</span>
                </button>
                <button
                  class="btn-back-otp"
                  style="
                    background: none;
                    border: none;
                    margin-left: 20px;
                    cursor: pointer;
                  "
                  @click="backToRegisterForm"
                >
                  Regresar
                </button>
              </div>
            </div>
          </div>

          <div
            v-show="activeTab === 'guest'"
            class="tab-content"
            :class="{ active: activeTab === 'guest' }"
          >
            <p class="subtitle">
              Finaliza tu compra sin necesidad de crear una cuenta
            </p>

            <div class="btn-center">
              <a class="btn btn-next" @click="type_nav = 2"
                >Continuar como invitado</a
              >
            </div>
          </div>
        </div>
        <!-- :class="{'active': loggedIn}" -->
        <div class="form-step" :class="{ active: type_nav == 2 }">
          <!-- <p class="d-block d-sm-none"> Información del cliente</p> -->
          <div class="" :class="{ 'd-none': loggedIn }">
            <div class="input-flex">
              <div class="input-group">
                <label for="full-name">Nombre Completo</label>
                <input
                  type="text"
                  v-model="client_guest.full_name"
                  @input="sanitizeField($event, 'client_guest.full_name')"
                  name="full-name"
                  id="full-name"
                />
              </div>

              <div class="input-group">
                <label for="email">Correo electrónico</label>
                <input
                  type="email"
                  v-model="client_guest.email"
                  @input="sanitizeField($event, 'client_guest.email')"
                  name="email"
                  id="email"
                />
              </div>

              <div class="input-group">
                <label for="phone">Número de teléfono</label>
                <input
                  type="number"
                  v-model="client_guest.phone"
                  @input="sanitizeField($event, 'client_guest.phone')"
                  name="phone"
                  maxlength="9"
                  id="phone"
                  placeholer="99999999"
                />
              </div>

              <div class="input-group">
                <label for="phone">DUI:</label>
                <input
                  type="text"
                  name="dui"
                  @input="sanitizeAndApplyMask"
                  maxlength="10"
                  id="dui"
                  v-model="client_guest.dui"
                  placeholer=""
                />
              </div>

              <div
                class="message-alert message-alert-checkout"
                v-if="PHONE_ERROR_TEXT"
              >
                <span class="close-button" @click="PHONE_ERROR_TEXT = null"
                  >&times;</span
                >
                <p>{{ PHONE_ERROR_TEXT }}</p>
              </div>
              <div
                class="message-alert message-alert-checkout"
                v-if="DUI_ERROR_TEXT"
              >
                <span class="close-button" @click="DUI_ERROR_TEXT = null"
                  >&times;</span
                >
                <p>{{ DUI_ERROR_TEXT }}</p>
              </div>
            </div>

            <!-- <div class="input-flex">
                            <div class="input-group">
                                <label>Departamento Factura:</label>
                                <select id="dpto" name="departamento"  @change="changeLocation" v-model="client_guest.departament_factura">
                                     <template
                                        v-for="(DEPARTAMENTO, index) in S_DEPARTAMENTOS"
                                        :key="index"
                                    >
                                        <option :value="DEPARTAMENTO.name">{{DEPARTAMENTO.name}}</option>
                                    </template>
</select>
</div>

<div class="input-group">
    <label>Municipio Factura:</label>
    <select id="municipio" name="municipio" v-model="client_guest.municipality_factura">
        <template v-for="(MUNICIPIO, index) in S_MUNICIPIOS" :key="index">
                                        <option :value="MUNICIPIO.city">{{MUNICIPIO.city}}</option>
                                    </template>
    </select>
</div>
</div> -->
            <!-- <div class="input-group">
                            <label>Dirección Completa*
                            </label>
                            <input type="text" v-model="client_guest.address_factura">
                        </div> -->
          </div>

          <div class="bg-info2" v-if="loggedIn">
            <ul>
              <li><span>Nombre:</span> {{ client_guest.full_name }}</li>
              <li><span>Correo:</span> {{ client_guest.email }}</li>

              <li v-if="client_guest_phone_initial">
                <span>Teléfono:</span> {{ client_guest.phone }}
              </li>
              <div
                v-else
                class="input-group"
                style="margin-top: 10px; margin-bottom: 10px"
              >
                <label for="phone-logged-in">Número de teléfono *</label>
                <input
                  type="text"
                  v-model="client_guest.phone"
                  @input="handlePhoneInput"
                  name="phone-logged-in"
                  maxlength="8"
                  id="phone-logged-in"
                  placeholder="Ej: 77775555"
                />
              </div>

              <li v-if="client_guest_dui_initial">
                <span>DUI:</span> {{ client_guest.dui }}
              </li>
              <div
                v-else
                class="input-group"
                style="margin-top: 10px; margin-bottom: 10px"
              >
                <label for="dui-logged-in">DUI *</label>
                <input
                  type="text"
                  name="dui-logged-in"
                  @input="sanitizeAndApplyMask"
                  maxlength="10"
                  id="dui-logged-in"
                  v-model="client_guest.dui"
                  placeholder="00000000-0"
                />
              </div>
            </ul>
          </div>

          <div class="gps-flex" v-show="mapa_error">
            <img src="/assets/images/checkout/marcador.png" alt="" />
            <p>
              Si tu ubicacion es la del envio, se recomienda encender tu GPS
              para obtener una ubicación más precisa.
            </p>
          </div>
          <!-- <div class="btn-gps">
                        <button> <a class="btn btn-green">Activar GPS</a></button>
                    </div> -->

          <!-- <div class="input-group" v-if="loggedIn">
                        <label>Dirección:</label>
                        <select id="addre" name="address" @change="changeAddress">
                            <option value="">-- Selecciona una dirección--</option>
                            <template v-for="(ADDRE,index) in ADDRESS" :key="index">
                                <option :value="ADDRE.id">{{ADDRE.title}}</option>
                            </template>
                        </select>
                    </div> @click="new_direction = !new_direction" Enviar a otra ubicación :class="{'d-none': !new_direction}" -->

          <div class="input-group">
            <label for="phone"
              >Comentarios Adicional de tu orden: (Opcional)</label
            >
            <textarea
              name=""
              id=""
              cols="30"
              rows="4"
              v-model="client_guest.description"
              @input="sanitizeField($event, 'client_guest.description')"
            ></textarea>
          </div>

          <div class="input-1">
            <p>
              <label
                >¿Quiere Crédito Fiscal de la compra?&nbsp;<span
                  class="optional"
                  >(opcional)</span
                >
              </label>
            </p>

            <div class="switch">
              <input
                type="checkbox"
                id="switchID"
                v-model="is_credito_fiscal"
                @change="toggleCreditoFiscal"
              />
              <label for="switchID">
                <span class="switch-text switch-text-on">Sí</span>
                <span class="switch-text switch-text-off">No</span>
                <div class="toggle"></div>
              </label>
            </div>

            <div
              id="camposOpcion1"
              v-show="is_credito_fiscal"
              class="input group"
            >
              <div class="input-flex">
                <label>NIT: </label>
                <input
                  type="text"
                  placeholder="0000-000000-000-0"
                  @input="sanitizeAndUpdateMaskNit"
                  v-model="client_guest.nit"
                />
                <label>NRC:</label>
                <input
                  type="text"
                  placeholder="000000-0"
                  @input="sanitizeAndUpdateMaskNrc"
                  v-model="client_guest.nrc"
                />
                <label>Giro:</label>
                <input
                  type="text"
                  maxlength="200"
                  v-model="client_guest.giro"
                  @input="sanitizeField($event, 'client_guest.giro')"
                />
              </div>
              <div
                class="message-alert message-alert-checkout"
                v-if="NIT_NRC_ERROR_TEXT"
              >
                <span class="close-button" @click="NIT_NRC_ERROR_TEXT = null"
                  >&times;</span
                >
                <p>{{ NIT_NRC_ERROR_TEXT }}</p>
              </div>

              <!-- <button class="collapcheckout" onclick="return false;" >Información de facturación: </button> -->

              <div class="">
                <div class="input-flex">
                  <div class="input-group">
                    <label>Departamento:</label>
                    <select
                      id="dpto"
                      name="departamento"
                      @change="changeLocation"
                      v-model="client_guest.departament_factura"
                    >
                      <option selected disabled value="">Selecciona...</option>
                      <template
                        v-for="(DEPARTAMENTO, index) in S_DEPARTAMENTOS"
                        :key="index"
                      >
                        <option :value="DEPARTAMENTO.name">
                          {{ DEPARTAMENTO.name }}
                        </option>
                      </template>
                    </select>
                  </div>
                  <div class="input-group">
                    <label>Municipio:</label>
                    <select
                      id="municipio"
                      name="municipio"
                      v-model="client_guest.municipality_factura"
                    >
                      <option selected disabled value="">Choose...</option>
                      <template
                        v-for="(MUNICIPIO, index) in S_MUNICIPIOS"
                        :key="index"
                      >
                        <option :value="MUNICIPIO.city">
                          {{ MUNICIPIO.city }}
                        </option>
                      </template>
                    </select>
                  </div>
                </div>
                <div class="input-group">
                  <label>Dirección Completa* </label>
                  <input
                    type="text"
                    v-model="client_guest.address_factura"
                    @input="
                      sanitizeField($event, 'client_guest.address_factura')
                    "
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="btn-group py-4">
            <!-- :class="{'btn-prev': !loggedIn}" -->
            <a class="btn btn-prev" v-if="!loggedIn" @click="type_nav = 1">
              Volver</a
            >
            <router-link to="/cart" class="btn btn-prev" v-if="loggedIn">
              Carrito
            </router-link>
            <!-- <a class="btn btn-prev disabled" v-if="loggedIn">
                            Volver
                        </a> -->
            <a class="btn btn-next" @click="nextInfoDelivery()">Siguiente</a>
          </div>
        </div>

        <div class="form-step" :class="{ active: type_nav == 3 }">
          <!-- <p class="d-block d-sm-none"> Información de entrega</p> -->
          <div class="tab-container">
            <ul class="tab-menu" id="tab-menu2">
              <li>
                <a
                  href="#tab-content4"
                  :class="{ active: activeTabDelivery === 'domicilio' }"
                  @click.prevent="changeTabDelivery('domicilio')"
                >
                  <img src="/assets/images/checkout/Delivery.svg" alt="" />
                  Envio a domicilio</a
                >
              </li>
              <li
                v-if="
                  !(
                    !sucursal_validate.length ||
                    (sucursal_validate.length === 1 &&
                      sucursal_validate.some(
                        (s) => s.name === 'Warehouse Matrix'
                      ))
                  )
                "
              >
                <a
                  href="#tab-content3"
                  :class="{ active: activeTabDelivery === 'sucursal' }"
                  @click.prevent="changeTabDelivery('sucursal')"
                >
                  <img src="/assets/images/checkout/Map Point.svg" alt="" />
                  Recoger en Sucursal</a
                >
              </li>
            </ul>
            <div
              id="tab-content3"
              :class="{ active: activeTabDelivery === 'sucursal' }"
              class="tab-content"
            >
              <h2>Selecciona una sucursal</h2>
              <div
                class="sucursales-flex1"
                v-if="loadingSucursal && !SucursalEmpty"
              >
                <!-- 
                                 -->
                <label
                  v-if="white && isAvalibleSucursal('San Salvador')"
                  :class="{
                    'sucursales-checked':
                      delivery_information.sucursal == 'San Salvador',
                  }"
                >
                  <input
                    type="checkbox"
                    name="sucursal"
                    value="metrocentro"
                    @click="selectedTypeSucursal('San Salvador')"
                  />
                  <img
                    src="/assets/logos/checkout/s-metrocentro-light.webp"
                    alt="San Salvador"
                    title="San Salvador"
                  />
                  <p>San Salvador</p>
                </label>

                <label
                  v-if="white && isAvalibleSucursal('Plaza Merliot')"
                  :class="{
                    'sucursales-checked':
                      delivery_information.sucursal == 'Plaza Merliot',
                  }"
                >
                  <input
                    type="checkbox"
                    name="sucursal"
                    value="plaza-merliot"
                    @click="selectedTypeSucursal('Plaza Merliot')"
                  />
                  <img
                    src="/assets/logos/checkout/s-plazamerliot-light.webp"
                    alt="Plaza Merliot"
                    title="Plaza Merliot"
                  />
                  <p>Plaza Merliot</p>
                </label>

                <label
                  v-if="white && isAvalibleSucursal('Plaza Mundo')"
                  :class="{
                    'sucursales-checked':
                      delivery_information.sucursal == 'Plaza Mundo',
                  }"
                >
                  <input
                    type="checkbox"
                    name="sucursal"
                    value="plaza-mundo"
                    @click="selectedTypeSucursal('Plaza Mundo')"
                  />
                  <img
                    src="/assets/logos/checkout/s-plazamundo-light.webp"
                    alt="Plaza Mundo"
                    title="Plaza Mundo"
                  />
                  <p>Plaza Mundo</p>
                </label>

                <label
                  v-if="white && isAvalibleSucursal('San Miguel')"
                  :class="{
                    'sucursales-checked':
                      delivery_information.sucursal == 'San Miguel',
                  }"
                >
                  <input
                    type="checkbox"
                    name="sucursal"
                    value="san-miguel"
                    @click="selectedTypeSucursal('San Miguel')"
                  />
                  <img
                    src="/assets/logos/checkout/s-metrocentro-light.webp"
                    alt="San Miguel"
                    title="San Miguel"
                  />
                  <p>San Miguel</p>
                </label>

                <!-- <label v-if="white && isAvalibleSucursal('Warehouse Matrix')">
                                    <input type="checkbox" name="sucursal" value="bodega" @click="selectedTypeSucursal('Warehouse Matrix')">
                                    <img src="/assets/logos/checkout/logos-bodega-light.png" alt="Bodega"
                                        title="Bodega">
                                    <p>Bodega</p>
                                </label> -->

                <!--  -->
                <label
                  v-if="dark && isAvalibleSucursal('San Salvador')"
                  :class="{
                    'sucursales-checked':
                      delivery_information.sucursal == 'San Salvador',
                  }"
                >
                  <input
                    type="checkbox"
                    name="sucursal"
                    value="metrocentro"
                    @click="selectedTypeSucursal('San Salvador')"
                  />
                  <img
                    src="/assets/logos/checkout/s-metrocentro-dark.webp"
                    alt="San Salvador"
                    title="San Salvador"
                  />
                  <p>San Salvador</p>
                </label>

                <label
                  v-if="dark && isAvalibleSucursal('Plaza Merliot')"
                  :class="{
                    'sucursales-checked':
                      delivery_information.sucursal == 'Plaza Merliot',
                  }"
                >
                  <input
                    type="checkbox"
                    name="sucursal"
                    value="plaza-merliot"
                    @click="selectedTypeSucursal('Plaza Merliot')"
                  />
                  <img
                    src="/assets/logos/checkout/s-plazamerliot-dark.webp"
                    alt="Plaza Merliot"
                    title="Plaza Merliot"
                  />
                  <p>Plaza Merliot</p>
                </label>

                <label
                  v-if="dark && isAvalibleSucursal('Plaza Mundo')"
                  :class="{
                    'sucursales-checked':
                      delivery_information.sucursal == 'Plaza Mundo',
                  }"
                >
                  <input
                    type="checkbox"
                    name="sucursal"
                    value="plaza-mundo"
                    @click="selectedTypeSucursal('Plaza Mundo')"
                  />
                  <img
                    src="/assets/logos/checkout/s-plazamundo-dark.webp"
                    alt="Plaza Mundo"
                    title="Plaza Mundo"
                  />
                  <p>Plaza Mundo</p>
                </label>

                <label
                  v-if="dark && isAvalibleSucursal('San Miguel')"
                  :class="{
                    'sucursales-checked':
                      delivery_information.sucursal == 'San Miguel',
                  }"
                >
                  <input
                    type="checkbox"
                    name="sucursal"
                    value="metrocentro"
                    @click="selectedTypeSucursal('San Miguel')"
                  />
                  <img
                    src="/assets/logos/checkout/s-metrocentro-dark.webp"
                    alt="San Miguel"
                    title="San Miguel"
                  />
                  <p>San Miguel</p>
                </label>

                <!-- <label v-if="dark && isAvalibleSucursal('Warehouse Matrix')">
                                    <input type="checkbox" name="sucursal" value="bodega" @click="selectedTypeSucursal('Warehouse Matrix')">
                                    <img src="/assets/logos/checkout/logos-bodega-dark.png" alt="Bodega"
                                        title="Bodega">
                                    <p>Bodega</p>
                                </label> -->
              </div>
              <div
                class="sucursales-flex1 mt-1"
                v-if="!loadingSucursal && !SucursalEmpty"
              >
                <img
                  src="/assets/svg/loading-store.gif"
                  style="height: 250px"
                  alt=""
                  srcset=""
                />
              </div>
              <div
                class="sucursales-flex1 mt-1"
                v-if="loadingSucursal && SucursalEmpty"
              >
                <img
                  src="/assets/svg/outofstock-store.svg"
                  style="height: 250px"
                  alt=""
                  srcset=""
                />
              </div>

              <div
                class="message-alert message-alert-checkout"
                v-if="SUCURSAL_ERROR_TEXT"
              >
                <span class="close-button" @click="SUCURSAL_ERROR_TEXT = null"
                  >&times;</span
                >
                <p>{{ SUCURSAL_ERROR_TEXT }}</p>
              </div>
            </div>
            <div
              id="tab-content4"
              :class="{ active: activeTabDelivery === 'domicilio' }"
              class="tab-content"
            >
              <h2>Dirección de Envío</h2>

              <div class="input-group" v-if="loggedIn">
                <label>Dirección:</label>
                <select id="addres" name="address" @change="changeAddress">
                  <option value="">-- Selecciona una dirección--</option>
                  <template v-for="(ADDRE, index) in ADDRESS" :key="index">
                    <option :value="ADDRE.id">{{ ADDRE.title }}</option>
                  </template>
                </select>
              </div>

              <div
                class="message-alert message-alert-checkout"
                v-if="SUCURSAL_ERROR_TEXT"
              >
                <span class="close-button" @click="SUCURSAL_ERROR_TEXT = null"
                  >&times;</span
                >
                <p>{{ SUCURSAL_ERROR_TEXT }}</p>
              </div>

              <button
                class="collapcheckout"
                v-if="loggedIn && !ADDRES_SELECTED"
                onclick="return false;"
                @click="resetAddress"
              >
                Enviar a otra ubicación
              </button>

              <div class="bg-info2" v-if="ADDRES_SELECTED">
                <h5 class="subtitle-t">Información de la dirección</h5>
                <ul>
                  <li>
                    <span>Departamento:</span> {{ client_guest.departament }}
                  </li>
                  <li>
                    <span>Municipio:</span> {{ client_guest.municipality }}
                  </li>
                </ul>
                <div class="input-group">
                  <label for="phone"
                    >Dirección Completa: {{ client_guest.address }}</label
                  >
                </div>
                <div class="input-group">
                  <label for="phone"
                    >Puntos de referencia:
                    {{ client_guest.point_reference }}</label
                  >
                </div>
                <!-- <div class="my-3">
                  <div
                    class="google-map"
                    ref="googleMap"
                    style="height: 300px"
                  ></div>
                </div> -->
              </div>
              <div
                class=""
                v-if="(!ADDRES_SELECTED && OPTION_SELECTED) || !loggedIn"
              >
                <div class="input-flex">
                  <div class="input-group">
                    <label>Departamento:</label>
                    <select
                      id="dpto"
                      name="departamento"
                      @change="changeLocation"
                      v-model="client_guest.departament"
                    >
                      <option selected disabled value="">Selecciona...</option>
                      <template
                        v-for="(DEPARTAMENTO, index) in S_DEPARTAMENTOS"
                        :key="index"
                      >
                        <option :value="DEPARTAMENTO.name">
                          {{ DEPARTAMENTO.name }}
                        </option>
                      </template>
                    </select>
                  </div>
                  <div class="input-group">
                    <label>Municipio:</label>
                    <select
                      id="municipio"
                      name="municipio"
                      v-model="client_guest.municipality"
                    >
                      <option selected disabled value="">Selecciona...</option>
                      <template
                        v-for="(MUNICIPIO, index) in S_MUNICIPIOS"
                        :key="index"
                      >
                        <option :value="MUNICIPIO.city">
                          {{ MUNICIPIO.city }}
                        </option>
                      </template>
                    </select>
                  </div>
                </div>
                <div class="input-group">
                  <label>Dirección Completa* </label>
                  <input
                    type="text"
                    v-model="client_guest.address"
                    @input="sanitizeField($event, 'client_guest.address')"
                  />
                </div>
                <div class="input-group">
                  <label>Puntos de referencia </label>
                  <input
                    type="text"
                    v-model="client_guest.point_reference"
                    @input="
                      sanitizeField($event, 'client_guest.point_reference')
                    "
                  />
                </div>
                <!-- <div class="my-3">
                  <p class="alert-valido">
                    Permite acceder a la ubicación GPS de tu dispositivo.
                    Actualiza la página si es necesario para obtener tu posición
                    actual. Puedes ampliar el mapa y hacer clic para ajustar tu
                    ubicación según sea necesario.
                  </p>
                  <div
                    class="google-map"
                    ref="googleMap"
                    style="height: 300px"
                  ></div>
                </div> -->
                <div class="input-group" v-if="!ADDRES_SELECTED && loggedIn">
                  <label>Puedes guardar la dirección para futuros usos </label>
                  <div class="input-flex2">
                    <input
                      type="text"
                      name="coupon"
                      class="form-control3 direcc-input"
                      v-model="title"
                      placeholder="Nombre de la ubicación"
                    />
                    <button
                      type="button"
                      @click="SaveAddress()"
                      class="btn-green"
                    >
                      GUARDAR
                    </button>
                  </div>
                </div>
              </div>

              <!-- <div class="input-group">
                                <label>Dirección:</label>
                                <input type="text">
                            </div>

                            <div class="input-group">
                                <label>Punto de Referencia:</label>
                                <input type="text">
                            </div>

                            <div class="gps-flex">
                                <img src="/assets/images/checkout/marcador.png" alt="">
                                <p>Si tu ubicacion es la del envio, se recomienda encender tu GPS para obtener una
                                    ubicación más precisa.
                                </p>

                            </div>
                            <div class="btn-gps">
                                <button> <a class="btn btn-green">Activar GPS</a></button>
                            </div>

                            <div class="ubicacion">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1056.798924578466!2d-89.2184058503832!3d13.696844869173296!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f6327a659640657%3A0x6f9a16eb98854832!2sEl%20Salvador!5e0!3m2!1ses-419!2sve!4v1689621304744!5m2!1ses-419!2sve"
                                    width="900" height="450" style="border:0;" allowfullscreen="" loading="lazy"
                                    referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div> -->
            </div>
          </div>

          <div class="btn-group">
            <a
              class="btn btn-prev"
              href="#"
              onclick="return false"
              @click="type_nav = 2"
              >Volver
            </a>
            <a class="btn btn-next" @click="nextInfoEntrega()">Siguiente</a>
          </div>
        </div>

        <div class="form-step" :class="{ active: type_nav == 4 }">
          <!-- <p class="d-block d-sm-none"> Información de pago</p> -->
          <ul class="tab-menu" id="tab-menupay">
            <li>
              <a
                href="#tab-content1a"
                :class="{ active: activeTabPay === 'tarjeta' }"
                @click.prevent="changeTabPay('tarjeta')"
              >
                <img src="/assets/images/checkout/Card.svg" alt="" />
                Pago con tarjeta</a
              >
            </li>
            <li>
              <a
                href="#tab-content3a"
                :class="{ active: activeTabPay === 'paypal' }"
                @click.prevent="changeTabPay('paypal')"
              >
                <img src="/assets/images/Nuevos/paypal.svg" alt="" />
                Paypal</a
              >
            </li>
            <li>
              <a
                href="#tab-content2a"
                :class="{ active: activeTabPay === 'transferencia' }"
                @click.prevent="changeTabPay('transferencia')"
              >
                <img src="/assets/images/checkout/transferencia.svg" alt="" />
                Transferencia</a
              >
            </li>

            <li v-if="loggedIn && orders_count > 2">
              <a
                href="#tab-content4a"
                :class="{ active: activeTabPay === 'contraentrega' }"
                @click.prevent="changeTabPay('contraentrega')"
              >
                <img src="/assets/svg/cash-on-delivery-w.svg" alt="" />
                Contra-Entrega</a
              >
            </li>
          </ul>

          <div class="tab-container">
            <div
              id="tab-content1a"
              :class="{ active: activeTabPay === 'tarjeta' }"
              class="tab-content"
            >
              <!-- <div class="mb-3">
                                <ul class="tab-menu">
                                    <li><a href="#" onclick="return false;" :class="{'active': selected_type_pay == 1}" @click="selectTypePay(1)">Pago completo</a></li>
                                    <li><a href="#" onclick="return false;" :class="{'active': selected_type_pay == 2}" @click="selectTypePay(2)">Pago cuotas</a></li>
                                </ul>
                            </div>

                            <div class="mb-3" v-if="selected_type_pay == 2">
                                <ul class="tab-menu">
                                    <li><a href="#" onclick="return false;" :class="{'active': selected_type_pay_cuotas == 1}" @click="selectTypePayCuotas(1)">3 Plazos</a></li>
                                    <li><a href="#" onclick="return false;" :class="{'active': selected_type_pay_cuotas == 2}" @click="selectTypePayCuotas(2)">6 Plazos</a></li>
                                    <li><a href="#" onclick="return false;" :class="{'active': selected_type_pay_cuotas == 3}" @click="selectTypePayCuotas(3)">9 Plazos</a></li>
                                    <li><a href="#" onclick="return false;" :class="{'active': selected_type_pay_cuotas == 4}" @click="selectTypePayCuotas(4)">12 Plazos</a></li>
                                </ul>
                            </div> -->

              <div class="pago-flex">
                <div class="form-pago">
                  <div>
                    <div class="box-cuotas">
                      <div class="flex-cuota">
                        <div>
                          <li>Pagar en Cuotas</li>
                        </div>

                        <div class="switch">
                          <input
                            type="checkbox"
                            id="switchID1"
                            @change="selectTypePay($event.target.checked)"
                          />
                          <label for="switchID1">
                            <span class="switch-text switch-text-on">Sí</span>
                            <span class="switch-text switch-text-off">No</span>
                            <div class="toggle"></div>
                          </label>
                        </div>
                      </div>
                      <br />

                      <br />
                      Disponible únicamente para pagos con tarjetas de crédito
                      <br /><br />

                      <!-- Selección de banco -->
                      <div class="mt-2" v-if="selected_type_pay === 2">
                        <h4>Seleccione su banco</h4>
                        <br />
                        <div
                          class="bank-options"
                          style="
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-start;
                            gap: 15px;
                          "
                        >
                          <div
                            class="bank-option"
                            :class="{ selected: selected_bank === 'bac' }"
                            @click="selectBank('bac')"
                          >
                            <img
                              src="/assets/images/checkout/america.png"
                              alt="Banco de América Central"
                            />
                            <span>Banco de América Central (BAC)</span>
                          </div>

                          <div
                            class="bank-option"
                            v-show="
                              Number(TOTAL_SUM) + (isTaxP() ? Number(tax) : 0) <
                              1000
                            "
                            :class="{ selected: selected_bank === 'agricola' }"
                            @click="selectBank('agricola')"
                          >
                            <img
                              src="/assets/images/checkout/agricola.png"
                              alt="Banco Agrícola"
                            />
                            <span>Banco Agrícola</span>
                          </div>
                        </div>
                        <!-- MENSAJE INFORMATIVO MEJORADO -->
                        <div
                          v-if="
                            selected_type_pay === 2 &&
                            selected_bank === 'agricola'
                          "
                          class="wompi-info-alert"
                        >
                          <div class="alert-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path
                                d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
                              ></path>
                              <line x1="12" y1="9" x2="12" y2="13"></line>
                              <line x1="12" y1="17" x2="12.01" y2="17"></line>
                            </svg>
                          </div>
                          <div class="alert-content">
                            Por favor, <strong>no cierres la ventana</strong> ni
                            uses el <strong>botón "Atrás"</strong>. Al finalizar
                            en Wompi, haz clic en
                            <strong>"Regresar al comercio"</strong> para ver el
                            detalle final de tu pedido.
                          </div>
                        </div>

                        <!-- Alertas informativas por banco -->
                        <!-- <div class="alert alert-info mt-2" v-if="selected_bank === 'bac'">
                                                    <strong>Banco de América Central:</strong> Su pago será procesado a través de PowerTrans.
                                                </div>
                                                <div class="alert alert-info mt-2" v-if="selected_bank === 'agricola'">
                                                    <strong>Banco Agrícola:</strong> Su pago será procesado con autenticación 3D Secure.
                                                </div> -->
                      </div>

                      <!-- Selección de cuotas (solo aparece cuando se selecciona un banco) -->
                      <div
                        id="additionalDiv"
                        class="additional-div mt-3"
                        v-show="selected_type_pay === 2 && selected_bank"
                        style="display: none"
                        v-if="
                          !(
                            selected_type_pay === 2 &&
                            selected_bank === 'agricola'
                          )
                        "
                      >
                        <label>Seleccione el número de cuotas:</label>
                        <select
                          name="selected_type_pay_cuotas"
                          id=""
                          v-model="selected_type_pay_cuotas"
                        >
                          <option value="1">3 meses</option>
                          <option value="2">6 meses</option>
                          <option value="3">9 meses</option>
                          <option value="4">12 meses</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="
                      selected_type_pay === 2 && selected_bank === 'agricola'
                    "
                    class="mt-4"
                  >
                    <!-- <button type="button" class="btn btn-dark" :disabled="creandoLink" @click="pagarConWompiEnlace" v-if="acepte_terminos">
                                            {{ creandoLink ? 'Creando enlace...' : 'Pagar con Banco Agricola (Wompi)'}}
                                        </button> -->
                    <p v-if="wompiError" class="text-danger mt-2">
                      {{ wompiError }}
                    </p>
                    <p class="text mt-1">
                      <strong>
                        Solo con tarjetas de crédito del Banco Agrícola.
                      </strong>
                    </p>
                    <p class="text mt-1">
                      <strong> (No tarjetas de débito)</strong>
                    </p>
                  </div>

                  <div
                    class="credit-card-box"
                    v-if="
                      !(selected_type_pay === 2 && selected_bank === 'agricola')
                    "
                  >
                    <div class="flip">
                      <div class="front">
                        <div class="chip"></div>

                        <div class="number">
                          {{
                            number_card.length > 0
                              ? number_card
                              : "0000 00000000 0000"
                          }}
                        </div>
                        <div class="card-holder">
                          <label>Nombre</label>
                          <div>{{ full_name_card }}</div>
                        </div>

                        <div class="card-visa" v-if="is_visa && is_visa == 1">
                          <img
                            src="/assets/images/checkout/pagos/Logo-tarjeta-Visa.png"
                            alt=""
                          />
                        </div>

                        <div class="card-visa" v-if="is_visa && is_visa == 2">
                          <img
                            src="/assets/images/checkout/pagos/Logo-tarjeta-Mastercard.png"
                            alt=""
                          />
                        </div>

                        <div class="card-visa" v-if="is_visa && is_visa == 3">
                          <img
                            src="/assets/images/checkout/pagos/Logo-tarjeta-AmericanExpress.png"
                            alt=""
                          />
                        </div>

                        <div class="card-expiration-date">
                          <label>Expira</label>
                          <div>{{ month_card }}/{{ year_card }}</div>
                        </div>
                      </div>
                      <div class="back">
                        <div class="strip"></div>

                        <div class="ccv">
                          <label>CVC</label>
                          <div>{{ cvv_card }}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="
                      !(selected_type_pay === 2 && selected_bank === 'agricola')
                    "
                  >
                    <div class="input-group">
                      <!-- oninput="aplicarMascara(this)"  -->
                      <label>Número de Tarjeta</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        placeholder="xxxx xxxx xxxx xxxx"
                        v-model="number_card"
                        @keyup="digitalCard($event.target.value)"
                        @paste="handlePaste($event, 'numberCard')"
                      />
                    </div>

                    <div class="input-group">
                      <label>Nombre de la tarjeta</label>
                      <input
                        type="text"
                        maxlength="20"
                        @keypress="isStringT($event)"
                        @keyup="fullNameCard($event.target.value)"
                        @paste="handlePaste($event, 'nameCard')"
                      />
                    </div>

                    <div class="input-flex">
                      <div class="input-group">
                        <label>Mes</label>
                        <select
                          name="mes"
                          @change="MonthCard($event.target.value)"
                        >
                          <option value="01">01</option>
                          <option value="02">02</option>
                          <option value="03">03</option>
                          <option value="04">04</option>
                          <option value="05">05</option>
                          <option value="06">06</option>
                          <option value="07">07</option>
                          <option value="08">08</option>
                          <option value="09">09</option>
                          <option value="10">10</option>
                          <option value="11">11</option>
                          <option value="12">12</option>
                        </select>
                      </div>

                      <div class="input-group">
                        <label for="">Año</label>
                        <select
                          name="Año"
                          @change="YearCard($event.target.value)"
                        >
                          <template
                            v-for="(year_prop, index) in year_propies"
                            :key="index"
                          >
                            <option
                              :value="year_prop.value"
                              :selected="year_card == year_prop.value"
                            >
                              {{ year_prop.year }}
                            </option>
                          </template>
                          <!-- <option value="20">2020</option>
                                                <option value="21">2021</option>
                                                <option value="22">2022</option>
                                                <option value="23">2023</option> -->
                        </select>
                      </div>
                    </div>
                    <div class="input-group">
                      <label>CVC</label>
                      <input
                        type="password"
                        inputmode="numeric"
                        placeholder="XXX"
                        maxlength="4"
                        v-model="cvv_card"
                        @keyup="cvvCard($event.target.value)"
                      />
                    </div>
                  </div>
                  <picture>
                    <img
                      src="/assets/images/checkout/pagos/Pago-con-tarjeta-mode-white.png"
                      alt="Pago con tarjeta"
                      class="only-light"
                    />
                    <img
                      src="/assets/images/checkout/pagos/Pago-con-tarjeta-mode-dark.png"
                      alt="Pago con tarjeta (oscuro)"
                      class="only-dark"
                    />
                  </picture>
                </div>

                <div class="resumen">
                  <div class="summery-wrap">
                    <div class="cart-wrap grand-total-wrap">
                      <h3>Resumen de la Orden</h3>
                      <div>
                        <div class="order-summery-box">
                          <ul class="order-summery">
                            <!---->
                            <li class="pb-0">
                              <span>Subtotal </span
                              ><span>$ {{ TOTAL_SUM.toFixed(2) }}</span>
                            </li>

                            <li class="pb-0" v-if="type_entrega == 2">
                              <span>Envío </span>

                              <span v-if="is_free == 2">GRATIS</span>
                              <span v-if="is_free == 1">
                                {{ tax == 0 ? "GRATIS" : "$ " + tax }}</span
                              >
                            </li>
                          </ul>

                          <ul class="order-summery">
                            <!-- <li class="pb-0"><span>Descuento </span><span>10%</span></li> -->
                          </ul>

                          <p class="price-total">
                            Total a Pagar
                            <span class="size-total"
                              >${{
                                (TOTAL_SUM + (isTaxP() ? tax : 0)).toFixed(2)
                              }}</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="tab-content2a"
              :class="{ active: activeTabPay === 'transferencia' }"
              class="tab-content"
            >
              <div class="pago-flex">
                <div class="form-pago">
                  <div class="alert alert-info alert-with-icon" role="alert">
                    <div class="aviso-flex">
                      <div class="alert-icon-box">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather feather-alert-triangle alert-icon"
                        >
                          <path
                            d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
                          ></path>
                          <line x1="12" y1="9" x2="12" y2="13"></line>
                          <line x1="12" y1="17" x2="12.01" y2="17"></line>
                        </svg>
                      </div>
                      <div>
                        <b><i class="fa fa-warning fa-lg"></i>Importante</b>
                      </div>
                    </div>

                    <div>
                      1. Realizar la transferencia desde la plataforma del banco
                      de su preferencia. <br />
                      2. Elija una de las siguientes cuentas a donde hará el
                      depósito:
                    </div>
                    <!-- <ul>
                                                <template v-for="(cuenta, index) in cuentas" :key="index">
                                                    <li>
                                                        <button type="button" onclick="return false;" @click="copyTextAccount(cuenta.n_cuenta)"> <img src="/assets/images/checkout/copiar.png"
                                                                style="width: 18px;"></button> &nbsp;Banco
                                                        {{ cuenta.banco }} - No Cuenta: {{ cuenta.n_cuenta }}
                                                    </li>
                                                </template>
                                            </ul> -->
                    3. Adjuntar captura de comprobante de Pago
                  </div>

                  <h2>Selecciona una cuenta bancaria:</h2>

                  <template v-for="(cuenta, index) in cuentas" :key="index">
                    <div class="box-select">
                      <div class="flex-cuenta">
                        <input
                          type="radio"
                          :id="'banco' + cuenta.id"
                          @click="selectedTypeCuentaBancaria(cuenta.id)"
                          name="banco"
                          value="201328200"
                        />
                        <label :for="'banco' + cuenta.id" class="inside">
                          <img
                            v-if="cuenta.id == 2"
                            src="/assets/images/checkout/america.png"
                            alt=""
                          />
                          <img
                            v-if="cuenta.id == 1"
                            src="/assets/images/checkout/cuscatlan.png"
                            alt=""
                          />
                          <img
                            v-if="cuenta.id == 3"
                            src="/assets/images/checkout/agricola.png"
                            alt=""
                          />
                          <img
                            v-if="cuenta.id == 4"
                            src="/assets/images/checkout/promerica.webp"
                            alt=""
                          />

                          <li>{{ cuenta.banco }}</li>
                          <br />
                          <div class="flex-cuenta">
                            <button
                              class="blue-option"
                              type="button"
                              onclick="return false;"
                              @click="copyTextAccount(cuenta.n_cuenta)"
                            >
                              <div>
                                <img
                                  src="/assets/images/checkout/copiar.png"
                                  style="width: 18px"
                                />
                              </div>
                              <div>
                                {{ cuenta.n_cuenta }} &nbsp; ZD, SA de CV &nbsp;
                                Cuenta Corriente
                              </div>
                            </button>
                          </div>
                        </label>
                      </div>
                    </div>
                  </template>

                  <div class="input-flex">
                    <div class="input-group">
                      <label>Titular Cuenta:</label>
                      <input
                        type="text"
                        maxlength="250"
                        @keypress="isStringT($event)"
                        v-model="payment_info.account_holder"
                      />
                    </div>

                    <div class="input-group">
                      <label>Concepto:</label>
                      <input
                        type="text"
                        maxlength="250"
                        @keypress="isStringAlfaNumer($event)"
                        v-model="payment_info.concept"
                      />
                    </div>
                  </div>

                  <div class="input-flex">
                    <div class="input-group">
                      <label>Número de referencia:</label>
                      <input
                        type="number"
                        v-model="payment_info.reference_number"
                      />
                    </div>

                    <div class="input-group">
                      <label>Monto:</label>
                      <input type="number" v-model="payment_info.amount" />
                    </div>
                  </div>

                  <div class="input-group">
                    <label
                      >Comprobante de Depósito: (jpg,jpeg, png, webp y pdf)
                      5MB</label
                    >
                    <input
                      type="file"
                      accept=".jpg, .jpeg, .png, .webp, .pdf"
                      @change="onFileChange"
                    />
                  </div>
                </div>

                <div class="resumen">
                  <div class="summery-wrap">
                    <div class="cart-wrap grand-total-wrap">
                      <h3>Resumen de la Orden</h3>
                      <div>
                        <div class="order-summery-box">
                          <ul class="order-summery">
                            <!---->
                            <li class="pb-0">
                              <span>Subtotal </span
                              ><span>$ {{ TOTAL_SUM.toFixed(2) }}</span>
                            </li>

                            <li class="pb-0" v-if="type_entrega == 2">
                              <span>Envío </span>
                              <span v-if="is_free == 2">GRATIS</span>
                              <span v-if="is_free == 1">
                                {{ tax == 0 ? "GRATIS" : "$ " + tax }}</span
                              >
                            </li>
                          </ul>

                          <!-- <ul class="order-summery">
                                                        <li class="pb-0"><span>Descuento </span><span>10%</span></li>
                                                    </ul> -->

                          <p class="price-total">
                            Total a Pagar
                            <span class="size-total"
                              >${{
                                (TOTAL_SUM + (isTaxP() ? tax : 0)).toFixed(2)
                              }}</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="tab-content3a"
              :class="{ active: activeTabPay === 'paypal' }"
              class="tab-content"
            >
              <div class="pago-flex">
                <div class="form-pago">
                  <div v-if="type_payment == 3 && acepte_terminos">
                    <PaypalButton
                      :clientGuest="client_guest"
                      :delivery_information="delivery_information"
                      :type_entrega="type_entrega"
                      :is_credito_fiscal="is_credito_fiscal"
                      :orderMeta="orderMeta"
                      @success="onPayPalSuccess"
                      @error="onErrorR"
                    />
                  </div>
                  <div>
                    <div class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        id="acepte_terminos"
                        v-model="acepte_terminos"
                        :true-value="1"
                        :false-value="0"
                      />
                      <label for="acepte_terminos" class="inside mb-0 mx-2">
                        Acepto los
                        <a
                          href="#"
                          data-bs-toggle="modal"
                          data-bs-target="#viewTerminosPages"
                          onclick="return false;"
                          class="text-primary"
                          target="_blank"
                          >términos y condiciones de pago</a
                        >
                        ,
                        <a
                          href="#"
                          data-bs-toggle="modal"
                          data-bs-target="#viewEntregasEnviosPages"
                          onclick="return false;"
                          class="text-primary"
                          target="_blank"
                          >envío</a
                        >
                        y
                        <a
                          href="#"
                          data-bs-toggle="modal"
                          data-bs-target="#viewPloticaGarantiaPages"
                          class="text-primary"
                          target="_blank"
                          >garantías</a
                        >
                        para empezar con Paypal
                      </label>
                    </div>
                  </div>
                </div>
                <div class="resumen">
                  <div class="summery-wrap">
                    <div class="cart-wrap grand-total-wrap">
                      <h3>Resumen de la Orden</h3>
                      <div>
                        <div class="order-summery-box">
                          <ul class="order-summery">
                            <!---->
                            <li class="pb-0">
                              <span>Subtotal </span
                              ><span>$ {{ TOTAL_SUM.toFixed(2) }}</span>
                            </li>

                            <li class="pb-0" v-if="type_entrega == 2">
                              <span>Envío </span>
                              <span v-if="is_free == 2">GRATIS</span>
                              <span v-if="is_free == 1">
                                {{ tax == 0 ? "GRATIS" : "$ " + tax }}</span
                              >
                            </li>

                            <li class="pb-0">
                              <span>PayPal VAT (Fee: $0.35+5.6%): </span>
                              <span>
                                ${{ paypalAmountLegacy().toFixed(2) }}
                              </span>
                            </li>
                          </ul>

                          <p class="price-total">
                            Total a Pagar
                            <span class="size-total"
                              >${{
                                (
                                  TOTAL_SUM +
                                  (isTaxP() ? tax : 0) +
                                  paypalAmountLegacy()
                                ).toFixed(2)
                              }}</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="tab-content4a"
              :class="{ active: activeTabPay === 'contraentrega' }"
              class="tab-content"
            >
              <div class="pago-flex">
                <div class="form-pago">
                  <!-- <div class="alert alert-info alert-with-icon" role="alert">
                                        <div class="aviso-flex">
                                            <div class="alert-icon-box">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round" class="feather feather-alert-triangle alert-icon">
                                                    <path
                                                        d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z">
                                                    </path>
                                                    <line x1="12" y1="9" x2="12" y2="13"></line>
                                                    <line x1="12" y1="17" x2="12.01" y2="17"></line>
                                                </svg>
                                            </div>
                                            <div><b><i class="fa fa-warning fa-lg"></i>Importante</b></div>
                                        </div>
                                        <div>
                                            1. Elija una de las siguientes opciones para pago. 
                                            <br>
                                            2. Llene la información solicitada.
                                        </div>
                                    </div> -->

                  <!-- <h2>Selecciona una tipo de pago:</h2>

                                    <div class="box-select mb-0" @click="selectedTypePayment(1)">
                                        <div class="flex-cuenta">
                                            <input type="checkbox" id="banco1" @click="selectedTypePayment(1)" :checked="type_payment_contra_entrega == 1" name="banco_type_payment" value="201328200">
                                            <label for="banco1" class="inside">
                                                <li> Efectivo</li>
                                            </label>
                                        </div>
                                    </div> -->

                  <div
                    class="input-flex w-50"
                    v-if="type_payment_contra_entrega == 1"
                  >
                    <div class="input-group">
                      <label>Cambio para:</label>
                      <input
                        type="number"
                        maxlength="15"
                        v-model="amount_efectivo_contra_entrega"
                      />
                    </div>
                  </div>

                  <!-- <div class="box-select mt-3 mb-0" @click="selectedTypePayment(2)">
                                        <div class="flex-cuenta">
                                            <input type="checkbox" id="banco2" @click="selectedTypePayment(2)" :checked="type_payment_contra_entrega == 2" name="banco_type_payment" value="201328200">
                                            <label for="banco2" class="inside">
                                                <li> Pago con tarjeta</li>
                                            </label>
                                        </div>
                                    </div>

                                    <div class="input-flex w-50" v-if="type_payment_contra_entrega == 2">
                                        <div class="input-group">
                                            <label>Tipo: </label>
                                            <select name="mes" v-model="type_payment_card">
                                                <option value="1">PAGO DIRECTO</option>
                                                <option value="2">PAGO CUOTAS</option>
                                            </select>
                                        </div>
                                    </div> -->
                </div>

                <div class="resumen">
                  <div class="summery-wrap">
                    <div class="cart-wrap grand-total-wrap">
                      <h3>Resumen de la Orden</h3>
                      <div>
                        <div class="order-summery-box">
                          <ul class="order-summery">
                            <!---->
                            <li class="pb-0">
                              <span>Subtotal </span
                              ><span>$ {{ TOTAL_SUM.toFixed(2) }}</span>
                            </li>

                            <li class="pb-0" v-if="type_entrega == 2">
                              <span>Envío </span>
                              <span v-if="is_free == 2">GRATIS</span>
                              <span v-if="is_free == 1">
                                {{ tax == 0 ? "GRATIS" : "$ " + tax }}</span
                              >
                            </li>

                            <!-- <li class="pb-0" ><span>Comisión Paypal: </span>
                                                            <span> ${{ comisionPaypal().toFixed(2) }} </span>
                                                        </li> -->
                          </ul>

                          <p class="price-total">
                            Total a Pagar
                            <span class="size-total"
                              >${{
                                (
                                  TOTAL_SUM +
                                  (isTaxP() ? tax : 0) +
                                  paypalAmountLegacy()
                                ).toFixed(2)
                              }}</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div v-if="embed && !WARNING_TEXT" 
                        style="max-height: max-content;
                        height: max-content;">
                                <iframe id="threedsIframe" ref="threedsIframe" :srcdoc="embed" 
                                    style="width: 100%;height: 100%;"
                                >
                                </iframe>
                    </div> -->
          <!-- <div class="alert alert-info alert-with-icon" role="alert" v-if="type_payment == 2">
                        <div class="aviso-flex">
                            <div class="alert-icon-box">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-alert-triangle alert-icon">
                                    <path
                                        d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z">
                                    </path>
                                    <line x1="12" y1="9" x2="12" y2="13"></line>
                                    <line x1="12" y1="17" x2="12.01" y2="17"></line>
                                </svg>
                            </div>
                            <div><b><i class="fa fa-warning fa-lg"></i>Importante</b></div>
                        </div>
                        <div>
                            "El titular" debe presentar la tarjeta de crédito/débito y documento de identificación al
                            momento de recibir
                            el pedido.
                        </div>
                    </div> -->
          <!-- /termino-y-condiciones-de-uso href="/entregas-y-envios" href="/politica-de-garantia"-->
          <div class="d-flex align-items-center" v-if="type_payment != 3">
            <input
              type="checkbox"
              id="acepte_terminos"
              @click="acepte_terminos = acepte_terminos ? null : 1"
              :checked="acepte_terminos"
              name="acepte_terminos"
            />
            <label for="acepte_terminos" class="inside mb-0 mx-2">
              Acepto los
              <a
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#viewTerminosPages"
                onclick="return false;"
                class="text-primary"
                target="_blank"
                >términos y condiciones de pago</a
              >
              ,
              <a
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#viewEntregasEnviosPages"
                onclick="return false;"
                class="text-primary"
                target="_blank"
                >envío</a
              >
              y
              <a
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#viewPloticaGarantiaPages"
                class="text-primary"
                target="_blank"
                >garantías</a
              >
              al realizar la compra
            </label>
          </div>
          <div class="btn-group">
            <a
              href="#"
              onclick="return false;"
              :class="{ 'd-none': PROCESS_CARD }"
              class="btn btn-prev"
              @click="type_nav = 3"
              >Volver</a
            >

            <template v-if="type_payment != 3">
              <a
                data-bs-toggle="modal"
                data-bs-target="#viewTerminos"
                name="complete"
                class="btn btn-complete"
                v-if="!loading && !acepte_terminos"
                >Proceder a Pagar</a
              >
              <button
                @click="procesarPago()"
                :disabled="creandoLink && isWompi"
                type="button"
                name="complete"
                class="btn btn-complete"
                v-if="!loading && acepte_terminos"
              >
                Proceder a Pagar
              </button>
              <!-- Botón para procesar el pago -->
              <div class="loader-5 center" v-if="loading"><span></span></div>
            </template>
          </div>

          <div class="pago-flex">
            <div
              v-if="embed && !WARNING_TEXT"
              style="max-height: 300px; height: 300px"
            >
              <iframe
                id="threedsIframe"
                ref="threedsIframe"
                :srcdoc="embed"
                style="width: 100%; height: 100%"
              ></iframe>
            </div>
            <div class="message-warning" v-if="WARNING_TEXT">
              <span class="close-button" @click="WARNING_TEXT = null"
                >&times;</span
              >
              <p>{{ WARNING_TEXT }}</p>
            </div>
          </div>
        </div>
      </form>
    </section>
    <section class="section-b-space card-page" v-if="loader">
      <div class="loader_div">
        <div class="loader">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </section>
    <!-- Main End -->

    <ModalTerminos></ModalTerminos>
    <ModalPageTerminos></ModalPageTerminos>
    <ModalPageConditionPago></ModalPageConditionPago>
    <ModalPagePoliticaGarantia></ModalPagePoliticaGarantia>
    <Modal></Modal>
  </div>
</template>
<script>
import store from "../../plugins/store";
import myApi from "../../plugins/axios";
import secureApi from "@/plugins/axios-secure";
import { readGuestMinimal, writeGuestMinimal } from "@/utils/cartLocal";
import GoogleMapsApiLoader from "google-maps-api-loader";
import SALVADOR from "../../assets/js/salvador";
import { useMeta } from "vue-meta";
import PaypalButton from "./layouts/PaypalButton.vue";
import ModalTerminos from "./modal/ModalTerminos.vue";
import ModalPageTerminos from "./modal/ModalPageTerminos.vue";
import ModalPageConditionPago from "./modal/ModalPageConditionPago.vue";
import ModalPagePoliticaGarantia from "./modal/ModalPagePoliticaGarantia.vue";
// import { checkEmailReputation } from "@/utils/emailReputation";
import { useReCaptcha } from "vue-recaptcha-v3";
import { recaptchaPost } from "@/utils/recaptcha";
import Modal from "@/components/modal/Modal.vue";
export default {
  name: "NewCheckout",
  setup() {
    const { executeRecaptcha } = useReCaptcha();
    return { executeRecaptcha };
  },
  data() {
    return {
      activeTab: "login",
      activeTabPay: "tarjeta",
      activeTabDelivery: "domicilio",
      loggedIn: false,
      showOtpInput: false,
      isResendDisabled: false,
      timer: 0,
      emailAllowedRegex: /[a-zA-Z0-9@._+-]/,
      intervalId: null,
      client_guest: {
        full_name: null,
        email: null,
        phone: null,
        description: null,
        //
        nit: null,
        nrc: null,
        giro: null,
        dui: "",

        departament: null,
        municipality: null,
        address: null,
        point_reference: null,
        latitud: null,
        longitud: null,
        //
        departament_factura: null,
        municipality_factura: null,
        address_factura: null,
      },
      is_credito_fiscal: null,
      delivery_information: {
        sucursal: null,
        departament: null,
        municipality: null,
        address: null,
        point_reference: null,
      },
      payment_info: {
        account_holder: null,
        concept: null,
        reference_number: null,
        amount: null,
        type_cuenta_bancaria: 1,
      },
      S_MUNICIPIOS: [],
      BACKUP_MUNICIPIOS: [],
      S_DEPARTAMENTOS: [],
      //
      ADDRESS: [],
      ADDRES_SELECTED: null,
      // Login
      email_login: null,
      password_login: null,
      // Register
      name_register: null,
      surname_register: null,
      email_register: null,
      password_register: null,
      //
      CARTS: [],
      TOTAL_SUM: 0,
      // MAPS
      mapa_error: false,
      direccion_correcta: false,
      direccion_incorrecta: false,
      google: null,
      map: null,
      marker: null,
      latitud: 0,
      id: null,
      longitud: 0,
      referencia: null,
      numDeltas: 50,
      delay: 5,
      i: 0,
      loading: false,
      new_direction: null,
      // Variables para procesamiento de pago BAC
      embed: null,
      token_card: null,
      PROCESS_CARD: null,
      using3DSecurePopup: false,
      // ADDRESS
      title: null,
      departament: null,
      municipality: null,
      address: null,
      point_reference: null,
      //
      sucursal: null,
      photo_file: null,
      cuentas: [],
      //
      today: null,
      next_name_day: null,
      next_num_day: null,
      next_name_two_day: null,
      next_num_two_day: null,
      next_num_month: null,
      //
      is_visa: false,
      number_card: "",
      cvv_card: "",
      full_name_card: "",
      month_card: "01",
      year_card: (new Date().getFullYear() % 100) + "",
      year_propies: [],
      //
      type_payment: 2,
      type_entrega: 2,
      type_cuenta_bancaria: null,
      //
      tax: 2.5,
      is_free: 1,
      //
      type_nav: 1,
      //
      WARNING_TEXT: null,
      //
      PHONE_ERROR_TEXT: null,
      NIT_NRC_ERROR_TEXT: null,
      SUCURSAL_ERROR_TEXT: null,
      DUI_ERROR_TEXT: null,
      OPTION_SELECTED: false,
      //
      reference: {
        price: 0,
      },
      resultado_fac: null,
      client_guest_phone_initial: null,
      client_guest_dui_initial: null,
      //
      selected_type_pay: 1,
      selected_type_pay_cuotas: null,
      //
      type_payment_contra_entrega: 1,
      amount_efectivo_contra_entrega: 0,
      type_payment_card: "1",
      orders_count: 0,
      //
      white: null,
      dark: null,
      acepte_terminos: null,
      sucursal_validate: [],
      loadingSucursal: true,
      SucursalEmpty: null,
      loader: true,
      selected_bank: "bac",
      creandoLink: false,
      wompiError: "",
      wompiPopup: null,
      wompiTx: null,
    };
  },

  computed: {
    isWompi() {
      return (
        this.selected_type_pay === 2 &&
        this.selected_bank === "agricola" &&
        this.type_payment === 2
      );
    },
    userFromStore() {
      return this.$store?.state?.user || null;
    },
    userEmail() {
      return this.userFromStore?.email || "";
    },
    userPhone() {
      return this.userFromStore?.info.mobile || "";
    },
    userDui() {
      return this.userFromStore?.info.dui || "";
    },

    formattedTime() {
      const minutes = Math.floor(this.timer / 60);
      const seconds = this.timer % 60;
      return `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    },
  },

  watch: {
    userFromStore: {
      immediate: true,
      handler() {
        // Prefill solo si el campo está vacío en el form
        // if (!this.form?.email && this.userEmail) this.$set(this.form, "email", this.userEmail);
        // if (!this.form?.phone && this.userPhone) this.$set(this.form, "phone", this.userPhone);
        // Si tu payload usa otros nombres:
        // if (!this.form?.correo && this.userEmail) this.$set(this.form, "correo", this.userEmail);
        // if (!this.form?.telefono && this.userPhone) this.$set(this.form, "telefono", this.userPhone);
      },
    },
  },

  components: {
    PaypalButton,
    ModalTerminos,
    ModalPageTerminos,
    ModalPageConditionPago,
    ModalPagePoliticaGarantia,
    Modal,
  },

  methods: {
    async verificarTransaccion(idTransaccion) {
      try {
        const resp = await myApi.get("/payments/wompi/result", {
          params: { idTransaccion },
        });
        return resp.data;
      } catch (e) {
        console.error("Error verificando transacción:", e);
        return null;
      }
    },

    async esperarConfirmacion(idTransaccion) {
      const delays = [1000, 2000, 3000, 5000, 8000]; // Backoff exponencial

      for (let i = 0; i < delays.length; i++) {
        await new Promise((r) => setTimeout(r, delays[i]));

        const data = await this.verificarTransaccion(idTransaccion);

        if (data?.uniqd) {
          this.procesarPagoExitoso(data);
          return;
        }
      }

      throw new Error(
        "Transacción aún no confirmada. Por favor verifica tu cuenta."
      );
    },

    procesarPagoExitoso(data) {
      try {
        localStorage.removeItem("carts");
      } catch (e) {
        console.log(e);
      }

      this.$emit("pago-ok", data);
      this.wompiError = "";
      this.onPayPalSuccess({ uniqd: data.uniqd });
    },

    manejarErrorPago(e) {
      this.wompiError =
        e?.response?.data?.message ||
        e?.message ||
        "No se pudo finalizar el pago";
      this.$notify({
        title: "Error en el pago",
        text: this.wompiError,
        duration: 5000,
        type: "error",
      });
    },

    async pagarConWompiEnlace() {
      this.wompiError = "";
      if (!(this.selected_type_pay === 2 && this.selected_bank === "agricola"))
        return;

      try {
        this.creandoLink = true;
        const isGuest = !this.loggedIn;

        // Base común
        const payload = {
          type_entrega: this.type_entrega,
          sucursal:
            (this.delivery_information && this.delivery_information.sucursal) ||
            this.sucursal ||
            null,
          client_guest: this.client_guest
            ? {
                full_name: this.client_guest.full_name,
                email: this.client_guest.email,
                phone: this.client_guest.phone,
                dui: this.client_guest.dui,
                departament: this.client_guest.departament,
                municipality: this.client_guest.municipality,
                address: this.client_guest.address,
                point_reference: this.client_guest.point_reference,
                departament_factura: this.client_guest.departament_factura,
                municipality_factura: this.client_guest.municipality_factura,
                address_factura: this.client_guest.address_factura,
                nit: this.client_guest.nit,
                nrc: this.client_guest.nrc,
                giro: this.client_guest.giro,
                description: this.client_guest.description,
              }
            : {},
          delivery_information: this.delivery_information || {},
          is_credito_fiscal: !!this.is_credito_fiscal,
          config: { notificar: true },
        };

        // Invitado: activar checkout efímero + enviar items
        if (isGuest) {
          payload.force_new_checkout = true;

          const raw = JSON.parse(localStorage.getItem("carts") || "[]");
          const map = new Map();
          for (const p of Array.isArray(raw) ? raw : []) {
            if (!p?.uniqd) continue;
            const k = String(p.uniqd);
            const q = Number(p.quantity || 1);
            map.set(k, {
              uniqd: k,
              quantity:
                (map.get(k)?.quantity || 0) +
                (Number.isFinite(q) && q > 0 ? q : 1),
              code_discount: p.code_discount || 0,
              code_offer: p.code_offer || 0,
            });
          }
          const items = Array.from(map.values());
          if (!items.length) {
            this.wompiError = "Tu carrito está vacío";
            return;
          }
          payload.items = items;
        }

        // IMPORTANTE: usa el cliente NO encriptado para este endpoint
        const { data } = await myApi.post(
          "/payments/wompi/crear-link",
          payload,
          { withCredentials: true }
        );

        if (!data || !data.url) {
          this.wompiError = "No se recibió URL de Wompi";
          return;
        }

        window.location.href = data.url;
      } catch (e) {
          this.$notify({
        text: `  ${ e?.response?.data?.message_text || e?.response?.data?.message   ||"No se pudo crear el enlace"}`,
        duration: 3000,
        type: 'error'
        
      });
        this.wompiError =
         e?.response?.data.message_text || e?.response?.data?.message   ||"No se pudo crear el enlace";
      } finally {
        this.creandoLink = false;
      }
    },

    onPayPalSuccess(payload) {
      try {
        localStorage.removeItem("carts");
      } catch (e) {
        console.log(e);
      }

      const uniqd = payload?.uniqd;
      this.$notify({
        text: "¡Pago exitoso! Estamos procesando tu compra.",
        duration: 3000,
      });

      if (uniqd) {
        this.$router.push(`/orden-completa/${encodeURIComponent(uniqd)}`);
        return;
      }

      this.$router.push("/perfil-cliente");
    },
    changeTabDelivery(type) {
      this.activeTabDelivery = type;

      if (type === "domicilio") {
        this.selectedTypeEntrega(2);
      } else if (type === "sucursal") {
        this.selectedTypeEntrega(1);
      }
    },

    changeTabPay(type) {
      this.activeTabPay = type;

      if (type === "tarjeta") {
        this.selectTypePayment(2); // Pago con tarjeta
      } else if (type === "transferencia") {
        this.selectTypePayment(1); // Transferencia
      } else if (type === "paypal") {
        this.selectTypePayment(3); // PayPal
      } else if (type === "contraentrega") {
        this.selectTypePayment(4); // Contra-Entrega
      }
    },

    isTabActive(tabName, section) {
      if (section === "entrega") {
        return this.activeTabDelivery === tabName;
      } else if (section === "pago") {
        return this.activeTabPay === tabName;
      }
      return false;
    },

    async mergeGuestCartIntoAccount() {
      const minimal = readGuestMinimal();
      if (!minimal.length) return;

      // crea/actualiza líneas en el server (una por producto)
      await Promise.allSettled(
        minimal.map((m) =>
          myApi.post("ecommerce/carts/", {
            uniqd: String(m.uniqd),
            quantity: Math.max(1, Number(m.quantity || 1)),
          })
        )
      );

      // el server ahora es la verdad oficial => limpia local minimal o refleja desde server
      writeGuestMinimal([]); // opcional: limpiar
    },
    hydrateClientFromUser() {
      try {
        const u = this.$store?.state?.user || {};
        const info = u.info || {};

        const full =
          [u.name, u.surname].filter(Boolean).join(" ").trim() || u.name || "";

        this.client_guest.full_name = this.client_guest.full_name || full;
        this.client_guest.email = this.client_guest.email || u.email || "";
        this.client_guest.phone =
          this.client_guest.phone || (info.mobile ?? u.phone ?? "");
        this.client_guest.dui =
          this.client_guest.dui || (info.dui ?? u.dui ?? "");

        if (this.client_guest.nit === undefined)
          this.$set(this.client_guest, "nit", info.nit ?? "");
        if (this.client_guest.nrc === undefined)
          this.$set(this.client_guest, "nrc", info.nrc ?? "");
        if (this.client_guest.giro === undefined)
          this.$set(this.client_guest, "giro", info.giro ?? info.gito ?? "");
        if (this.client_guest.department === undefined)
          this.$set(
            this.client_guest,
            "department",
            info.department ?? info.departament ?? ""
          );
        if (this.client_guest.municipality === undefined)
          this.$set(this.client_guest, "municipality", info.municipality ?? "");
        if (this.client_guest.address === undefined)
          this.$set(this.client_guest, "address", info.address ?? "");
        if (this.client_guest.point_reference === undefined)
          this.$set(
            this.client_guest,
            "point_reference",
            info.point_reference ?? ""
          );

        // Flags para no sobreescribir si el usuario ya lo editó
        this.client_guest_phone_initial = !!this.client_guest.phone;
        this.client_guest_dui_initial = !!this.client_guest.dui;
      } catch (e) {
        console.log(e);
      }
    },

    // Pega TODAS estas funciones dentro de tu objeto `methods` en NewCheckout.vue

    async validateOtp() {
      this.loading = true;
      try {
        const otpCode = this.$refs.otpRefs.map((input) => input.value).join("");
        if (otpCode.length < 6) {
          this.loading = false;
          return;
        }
        let payload = { email: this.email_register, code: otpCode };
        await myApi.post("ecommerce/verify-otp", payload);
        this.$notify({
          title: "¡Cuenta verificada!",
          text: "Iniciando sesión para continuar con tu compra.",
          type: "success",
          duration: 3000,
        });
        this.email_login = this.email_register;
        this.password_login = this.password_register;
        await this.Login();
      } catch (error) {
        this.$notify({
          title: error?.response?.data?.error || "Código incorrecto",
          type: "error",
          duration: 4500,
        });
        this.$refs.otpRefs.forEach((input) => (input.value = ""));
        if (this.$refs.otpRefs[0]) {
          this.$refs.otpRefs[0].focus();
        }
      } finally {
        this.loading = false;
      }
    },

    handleOtpInput(e, index) {
      const value = e.target.value;
      if (value && index < this.$refs.otpRefs.length - 1) {
        this.$refs.otpRefs[index + 1].focus();
      }
      if (this.$refs.otpRefs.every((input) => input.value.length === 1)) {
        this.validateOtp();
      }
    },

    handleOtpBackspace(e, index) {
      if (!e.target.value && index > 0) {
        this.$refs.otpRefs[index - 1].focus();
      }
    },

    handleOtpPaste(e) {
      e.preventDefault();
      let pastedData = e.clipboardData
        .getData("text")
        .replace(/\D/g, "")
        .slice(0, 6);
      pastedData.split("").forEach((char, index) => {
        if (this.$refs.otpRefs[index]) {
          this.$refs.otpRefs[index].value = char;
        }
      });
      const nextIndex = Math.min(
        pastedData.length,
        this.$refs.otpRefs.length - 1
      );
      if (this.$refs.otpRefs[nextIndex]) {
        this.$refs.otpRefs[nextIndex].focus();
      }
      if (this.$refs.otpRefs.every((input) => input.value.length === 1)) {
        this.validateOtp();
      }
    },

    async resendCode() {
      try {
        await myApi.post("ecommerce/request-otp", {
          email: this.email_register,
        });
        this.$notify({
          title: "Código reenviado",
          type: "success",
          duration: 4500,
        });
        this.startTimer(600);
      } catch (error) {
        this.$notify({
          title: error?.response?.data?.error || "Error al reenviar",
          type: "error",
          duration: 4500,
        });
      }
    },

    startTimer(duration) {
      this.isResendDisabled = true;
      this.timer = duration;
      if (this.intervalId) clearInterval(this.intervalId);
      this.intervalId = setInterval(() => {
        if (this.timer > 0) {
          this.timer--;
        } else {
          clearInterval(this.intervalId);
          this.isResendDisabled = false;
        }
      }, 1000);
    },

    backToRegisterForm() {
      this.showOtpInput = false;
      if (this.intervalId) clearInterval(this.intervalId);
      this.isResendDisabled = false;
    },

    getenvioMarcaProd() {
      let codes = [];
      this.CARTS?.map((item) => {
        let id = item.uniqd;
        codes.push(id);
      });

      myApi
        .post("ecommerce/precio_envio_marca_producto", {
          productos: codes,
          total: this.TOTAL_SUM,
        })
        .then((resp) => {
          let {
            precio_envio_mas_barato,
            free_delivery,
            monto_minimo_envio_gratis,
          } = resp.data;

          // Si el nuevo precio no es 0 y es menor al actual, o si this.tax no ha sido asignado aún
          if (
            precio_envio_mas_barato > 0 &&
            (this.tax === 0 || precio_envio_mas_barato < this.tax)
          ) {
            this.tax = precio_envio_mas_barato;
          }

          // Si aplica envío gratuito, y el monto mínimo (que estás usando como precio) es menor que el actual y distinto de 0
          if (
            free_delivery &&
            monto_minimo_envio_gratis > 0 &&
            monto_minimo_envio_gratis < this.tax
          ) {
            this.tax = monto_minimo_envio_gratis;
          }
        });
    },

    // Reemplaza tu función applyMask existente por esta:
    applyMask() {
      let value = this.client_guest.dui.toString().replace(/\D/g, ""); // 1. Quita todo lo que no sea dígito
      value = value.slice(0, 9); // 2. Limita a un máximo de 9 dígitos

      if (value.length > 8) {
        // 3. Si hay 9 dígitos, aplica el formato 00000000-0
        this.client_guest.dui = value.slice(0, 8) + "-" + value.slice(8);
      } else {
        // 4. Si hay 8 o menos, solo muestra los números
        this.client_guest.dui = value;
      }
    },
    // Agrega esta nueva función dentro de methods:
    handlePhoneInput() {
      if (typeof this.client_guest.phone !== "string") return;

      // Quita cualquier caracter que no sea un número
      let phone = this.client_guest.phone.replace(/\D/g, "");

      // Limita la longitud a 8 dígitos
      if (phone.length > 8) {
        phone = phone.slice(0, 8);
      }

      // Actualiza el valor en el modelo de datos
      this.client_guest.phone = phone;
    },
    isValidDui(dui) {
      const regex = /^\d{8}-\d{1}$/;
      return regex.test(dui);
    },
    copyTextAccount(value) {
      const el = document.createElement("textarea");
      el.value = value;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
      this.$notify({
        title: "COPIAR",
        text: "SE COPIO EL TEXTO ",
        duration: 3500,
        type: "primary",
      });
    },
    selectedTypePayment(val) {
      this.type_payment_contra_entrega = val;
    },
    selectTypePay(checked) {
      if (checked) {
        this.selected_type_pay = 2;
        this.selected_type_pay_cuotas = 1;

        if (this.selected_bank) {
          setTimeout(() => {
            const divOculto = document.getElementById("additionalDiv");
            if (divOculto) {
              divOculto.style.display = "block";
            }
          }, 100);
        }
      } else {
        this.selected_type_pay = 1;
        this.selected_type_pay_cuotas = null;

        // Ocultar el div de cuotas
        setTimeout(() => {
          const divOculto = document.getElementById("additionalDiv");
          if (divOculto) {
            divOculto.style.display = "none";
          }
        }, 100);
      }
    },

    // Método para seleccionar el banco
    selectBank(bank) {
      this.selected_bank = bank;
      // console.log('selectBank - selected_type_pay_cuotas antes:', this.selected_type_pay_cuotas);

      // Si se selecciona Banco Agrícola y tiene seleccionado 9 o 12 meses, cambiar a 3 meses
      if (
        bank === "agricola" &&
        (this.selected_type_pay_cuotas === 3 ||
          this.selected_type_pay_cuotas === 4 ||
          this.selected_type_pay_cuotas === "3" ||
          this.selected_type_pay_cuotas === "4")
      ) {
        this.selected_type_pay_cuotas = 1; // Cambiar a 3 meses (valor 1)
        //console.log('Cambiado a 3 meses porque Banco Agrícola no soporta 9 o 12 meses');
      }

      // Mostrar el div de cuotas cuando se selecciona un banco
      if (this.selected_type_pay === 2) {
        setTimeout(() => {
          const divOculto = document.getElementById("additionalDiv");
          if (divOculto) {
            divOculto.style.display = "block";
          }
          // console.log('selectBank (después de mostrar div) - selected_type_pay_cuotas después:', this.selected_type_pay_cuotas);
        }, 100);
      }
    },

    // Método para procesar pagos con BAC (PowerTranz)
    async processBacPayment(sel_type_pay, sel_type_pay_cuotas) {
      try {
        this.loading = true;
        this.WARNING_TEXT = null;

        // Alerta de procesamiento con BAC
        let paymentTypeText = sel_type_pay === 1 ? "normal" : "a plazos";
        this.$notify({
          title: "PROCESANDO PAGO",
          text: `Procesando pago ${paymentTypeText} con BAC...`,
          duration: 3500,
          type: "info",
        });

        // Validar que todos los campos necesarios estén completos
        const cleanNumber = this.number_card?.replace(/\s/g, "");

        if (
          !cleanNumber ||
          (cleanNumber.startsWith("3") && cleanNumber.length < 15) ||
          (!cleanNumber.startsWith("3") && cleanNumber.length < 16)
        ) {
          this.WARNING_TEXT = "Por favor, ingrese un número de tarjeta válido.";
          this.loading = false;
          return;
        }

        if (!this.full_name_card) {
          this.WARNING_TEXT =
            "Por favor, ingrese el nombre del titular de la tarjeta.";
          this.loading = false;
          return;
        }

        if (!this.cvv_card || this.cvv_card.length < 3) {
          this.WARNING_TEXT = "Por favor, ingrese un código CVV válido.";
          this.loading = false;
          return;
        }

        if (!this.month_card || !this.year_card) {
          this.WARNING_TEXT =
            "Por favor, seleccione la fecha de vencimiento de la tarjeta.";
          this.loading = false;
          return;
        }

        if (sel_type_pay === 2 && !sel_type_pay_cuotas) {
          this.WARNING_TEXT = "Por favor, seleccione el número de plazos.";
          this.loading = false;
          return;
        }

        const dui = this?.client_guest?.dui
          ? String(this.client_guest.dui).trim()
          : null;

        // Preparar los datos para la API de BAC/PowerTranz
        const bacPaymentData = {
          card_pan: this.number_card.replace(/\s/g, ""),
          card_cvv: this.cvv_card,
          month_card: this.month_card,
          year_card: this.year_card,
          card_holder_name: this.full_name_card,
          client_guest: {
            dui,
            email: this.client_guest.email,
            phone: this.client_guest.phone,
          },
          total_payment:
            parseFloat(this.TOTAL_SUM) +
            (this.isTaxP() ? parseFloat(this.tax) : 0),
          sel_type_pay: parseInt(sel_type_pay),
          sel_type_pay_cuotas:
            sel_type_pay === 2 ? parseInt(sel_type_pay_cuotas) : 0,
        };

        // Log detallado para depuración

        // Llamar a la API de BAC/PowerTranz
        const response = await secureApi.post(
          "banc-api-request",
          bacPaymentData
        );

        // Log detallado de la respuesta para depuración
        // if (sel_type_pay === 2) {

        // }

        if (response.data && response.data.response) {
          // Verificar que la respuesta contenga los datos necesarios
          if (
            !response.data.response.RedirectData ||
            !response.data.response.SpiToken
          ) {
            throw new Error(
              "La respuesta de BAC no contiene los datos necesarios para la autenticación 3D Secure"
            );
          }

          // Almacenar el HTML para el formulario 3D Secure
          this.embed = response.data.response.RedirectData;
          let SpiToken = response.data.response.SpiToken;
          this.token_card = SpiToken;
          this.PROCESS_CARD = 1;

          // Guardar el HTML de RedirectData para mostrarlo en el iframe

          // Hacer scroll hacia abajo para mostrar el iframe
          window.scrollTo(0, document.body.scrollHeight);

          // Establecer las variables necesarias
          this.loading = true;
          this.WARNING_TEXT = null;
          this.PROCESS_CARD = 1;

          // Crear un objeto de transacción para almacenar temporalmente
          const transactionData = {
            transactionId: SpiToken,
            status: "pending",
            amount: bacPaymentData.total_payment,
            orderNumber: this.generateOrderId(),
            paymentMethod: sel_type_pay === 1 ? "bac_normal" : "bac_plazos",
            installments: sel_type_pay_cuotas,
          };

          // Verificar el estado del pago periódicamente
          let timeoutId = setInterval(async () => {
            try {
              const checkResponse = await secureApi.post(
                "checkout-valid-process",
                {
                  SpiToken: SpiToken,
                }
              );

              if (checkResponse.data.message == 200) {
                // Pago exitoso, almacenar la orden
                clearInterval(timeoutId);
                this.PROCESS_CARD = null;

                // Solo asignar resultado_fac si existe en la respuesta
                if (checkResponse.data.resultado_fac) {
                  this.resultado_fac = checkResponse.data.resultado_fac;
                }

                // Llamar a storeOrder con los datos de la transacción
                this.storeOrder(transactionData);

                this.$notify({
                  title: "PAGO EXITOSO",
                  text: `Su pago con BAC ha sido procesado correctamente. ¡Gracias por su compra!`,
                  duration: 3500,
                  type: "success",
                });
              } else if (checkResponse.data.message == 403) {
                // Pago pendiente, seguir verificando
              } else if (checkResponse.data.message == 500) {
                // Error en el pago, mostrar mensaje
                if (!this.errorCount) this.errorCount = 0;
                this.errorCount++;

                // Intentar obtener más detalles del error
                let errorDetails = "";
                if (checkResponse.data.error) {
                  errorDetails = checkResponse.data.error;
                  console.error("Detalles del error 500:", errorDetails);
                }

                // Para pagos a cuotas, mostrar información específica
                if (sel_type_pay === 2) {
                  console.error(
                    "Error en pago a cuotas. Detalles completos:",
                    JSON.stringify(checkResponse.data, null, 2)
                  );
                }

                if (this.errorCount >= 3) {
                  clearInterval(timeoutId);
                  this.PROCESS_CARD = null;
                  this.loading = false;

                  let errorMessage =
                    "Ha ocurrido un error al procesar el pago.";
                  if (sel_type_pay === 2) {
                    errorMessage +=
                      " Es posible que esta tarjeta no soporte pagos a cuotas o que el banco haya rechazado la transacción.";
                  }
                  if (errorDetails) {
                    errorMessage += " Detalles: " + errorDetails;
                  }

                  this.WARNING_TEXT = errorMessage;

                  this.$notify({
                    title: "ERROR EN EL PAGO",
                    text:
                      errorMessage +
                      " Por favor, intente nuevamente o contacte a soporte.",
                    duration: 5000,
                    type: "error",
                  });
                }
              }
            } catch (error) {
              console.error("Error al verificar estado del pago:", error);
              // Incrementar el contador de errores
              if (!this.errorCount) this.errorCount = 0;
              this.errorCount++;

              // Si hay demasiados errores consecutivos, detener la verificación
              if (this.errorCount >= 3) {
                clearInterval(timeoutId);
                this.WARNING_TEXT =
                  "Error al verificar el estado del pago. Por favor, contacte a soporte.";
                this.PROCESS_CARD = null;
                this.token_card = null;
                this.loading = false;

                this.$notify({
                  title: "ERROR EN LA VERIFICACIÓN",
                  text: "No se pudo verificar el estado de su pago. Por favor, contacte a soporte para confirmar el estado de su transacción.",
                  duration: 5000,
                  type: "error",
                });
              }
            }
          }, 5000); // Verificar cada 5 segundos
        } else {
          // Manejar error en el pago
          let errorMessage = "Error al procesar el pago con BAC. ";
          if (response.data && response.data.error) {
            errorMessage += response.data.error;
            console.error("Error específico de BAC:", response.data.error);

            // Verificar si hay un error específico relacionado con pagos a cuotas
            if (
              sel_type_pay === 2 &&
              response.data.error.toLowerCase().includes("cuota")
            ) {
              console.error("Error relacionado con pago a cuotas detectado");
            }
          } else if (response.data && response.data.response) {
            errorMessage +=
              "Revise los datos de su tarjeta e intente nuevamente.";
            console.error(
              "Respuesta incompleta de BAC:",
              response.data.response
            );
          } else {
            errorMessage += "No se recibió una respuesta válida del servidor.";
          }

          this.$notify({
            title: "ERROR EN EL PAGO",
            text: errorMessage,
            duration: 5000,
            type: "error",
          });

          this.WARNING_TEXT = errorMessage;
          console.error("Error en la respuesta de BAC:", response.data);
        }
      } catch (error) {
        console.log('error test', error)
        let errorMessage 
        if(error.response.status !== 409) {

          errorMessage = "Ocurrió un error al procesar el pago. ";
  
          if (error.message && error.message.includes("ventana")) {
            errorMessage +=
              "No se pudo abrir la ventana de verificación 3D Secure. Por favor, permita las ventanas emergentes y vuelva a intentarlo.";
          } else if (
            error.message &&
            error.message.includes("datos necesarios")
          ) {
            errorMessage +=
              "La respuesta del servidor no contiene los datos necesarios para continuar. Por favor, contacte a soporte.";
          } else if (error.response) {
            errorMessage +=
              "El servidor respondió con un error. Por favor, intente nuevamente o contacte a soporte.";
          } else if (error.request) {
            errorMessage +=
              "No se pudo conectar con el servidor. Verifique su conexión a internet e intente nuevamente.";
          } else {
            errorMessage +=
              "Por favor, intente nuevamente o use otro método de pago.";
          }
  
          this.WARNING_TEXT = errorMessage;
        }
        else {
          errorMessage = `${error.response.data.message_text ?? "Ocurrió un error al procesar el pago."} `
            // this.WARNING_TEXT = errorMessage;
        }
        // Mensaje de error más descriptivo basado en el tipo de error
          
        this.$notify({
          title: "ERROR EN EL PAGO",
          text: errorMessage,
          duration: 5000,
          type: "error",
        });
        this.loading = false;
      }
    },

    // Método para procesar pagos con Serfinsa (Banco Agrícola)
    async processSerfinsaPayment_legacy() {
      try {
        this.loading = true;
        this.WARNING_TEXT = null;

        // Alerta de procesamiento con Banco Agrícola
        this.$notify({
          title: "PROCESANDO PAGO",
          text: "Procesando pago a plazos con Banco Agrícola...",
          duration: 3500,
          type: "info",
        });

        // Validar que todos los campos necesarios estén completos
        if (
          !this.number_card ||
          this.number_card.replace(/\s/g, "").length < 16
        ) {
          this.WARNING_TEXT = "Por favor, ingrese un número de tarjeta válido.";
          this.loading = false;
          return;
        }

        if (!this.full_name_card) {
          this.WARNING_TEXT =
            "Por favor, ingrese el nombre del titular de la tarjeta.";
          this.loading = false;
          return;
        }

        if (!this.cvv_card || this.cvv_card.length < 3) {
          this.WARNING_TEXT = "Por favor, ingrese un código CVV válido.";
          this.loading = false;
          return;
        }

        if (!this.month_card || !this.year_card) {
          this.WARNING_TEXT =
            "Por favor, seleccione la fecha de vencimiento de la tarjeta.";
          this.loading = false;
          return;
        }

        if (this.selected_type_pay === 2 && !this.selected_type_pay_cuotas) {
          this.WARNING_TEXT = "Por favor, seleccione el número de plazos.";
          this.loading = false;
          return;
        }

        // Preparar los datos para la API de Serfinsa
        const serfinsaPaymentData = {
          card_number: this.number_card.replace(/\s/g, ""),
          card_cvv: this.cvv_card,
          card_expiration_month: this.month_card,
          card_expiration_year: this.year_card,
          card_holder_name: this.full_name_card,
          total_amount:
            parseFloat(this.TOTAL_SUM) +
            (this.isTaxP() ? parseFloat(this.tax) : 0),
          plazo_meses: parseInt(this.selected_type_pay_cuotas),
        };

        // Llamar a la API de Serfinsa
        const response = await secureApi.post(
          "serfinsa-compra-plazos",
          serfinsaPaymentData
        );

        // Verificar si la transacción fue aprobada
        if (
          response.data.resultado_fac &&
          response.data.resultado_fac.esAprobada
        ) {
          // Procesar respuesta exitosa
          const transactionData = {
            transactionId: response.data.resultado_fac.idTransaccion,
            authorizationCode: response.data.resultado_fac.codigoAutorizacion,
            status: "completed",
            amount: serfinsaPaymentData.total_amount,
            orderNumber: this.generateOrderId(),
            paymentMethod: "serfinsa_plazos",
            installments: serfinsaPaymentData.plazo_meses,
            // Incluir el transaction_identifier para enviarlo al backend
            serfinsa_identifier: response.data.resultado_fac.idTransaccion,
          };

          this.storeOrder(transactionData);

          this.$notify({
            title: "PAGO EXITOSO",
            text: `Su pago a ${serfinsaPaymentData.plazo_meses} plazos ha sido procesado correctamente. ¡Gracias por su compra!`,
            duration: 3500,
            type: "success",
          });
        } else {
          // Manejar error en el pago
          let errorMessage = "Error al procesar el pago. ";

          if (response.data.error) {
            errorMessage += response.data.error;
          } else if (
            response.data.resultado_fac &&
            response.data.resultado_fac.mensaje
          ) {
            errorMessage += response.data.resultado_fac.mensaje;
          } else {
            errorMessage +=
              "Por favor, verifique los datos e intente nuevamente.";
          }

          this.WARNING_TEXT = errorMessage;

          this.$notify({
            title: "ERROR DE PAGO",
            text: errorMessage,
            duration: 5000,
            type: "error",
          });
        }

        this.loading = false;
      } catch (error) {
        console.error("Error al procesar el pago con Serfinsa:", error);
        let errorMessage = "Ocurrió un error al procesar el pago. ";

        if (error.response && error.response.data) {
          if (error.response.data.error) {
            errorMessage += error.response.data.error;
          } else if (
            error.response.data.resultado_fac &&
            error.response.data.resultado_fac.mensaje
          ) {
            errorMessage += error.response.data.resultado_fac.mensaje;
          }
        } else {
          errorMessage += "Por favor, intente nuevamente.";
        }

        this.WARNING_TEXT = errorMessage;
        this.$notify({
          title: "ERROR DE PAGO",
          text: errorMessage,
          duration: 5000,
          type: "error",
        });

        this.loading = false;
      }
    },

    // Genera un UUID v4 para referencias
    generateUUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },

    // Genera un ID de orden único
    generateOrderId() {
      return "ORD-" + Date.now() + "-" + Math.floor(Math.random() * 1000);
    },
    selectTypePayCuotas(value) {
      this.selected_type_pay_cuotas = value;
    },
    selectTypePayment(value) {
      this.type_payment = value;
      //
      this.reference.price = (
        this.TOTAL_SUM +
        (this.isTaxP() ? this.tax : 0) +
        this.paypalAmountLegacy()
      ).toFixed(2);
    },
    isAvalibleSucursal(sucursalN) {
      let avalible_sucursal = this.sucursal_validate.find(
        (item) => item.name == sucursalN
      );
      if (avalible_sucursal) {
        return true;
      }
      return false;
    },
    // only_show_profile
    async showProfile() {
      const resp = await myApi.post("ecommerce/only_show_profile", {});

      this.client_guest.full_name =
        resp.data.client.name +
        " " +
        (resp.data.client.surname ? resp.data.client.surname : "");
      this.client_guest.email = resp.data.client.email;
      this.client_guest.phone = resp.data.client.mobile;
      this.client_guest_phone_initial = resp.data.client.mobile;

      this.client_guest.nit = resp.data.client.nit;
      this.client_guest.nrc = resp.data.client.nrc;
      this.client_guest.giro = resp.data.client.gito;
      this.client_guest.dui = resp.data.client.dui;
      this.client_guest_dui_initial = resp.data.client.dui;
      //
      this.client_guest.departament_factura = resp.data.client.departament;
      this.client_guest.municipality_factura = resp.data.client.municipality;
      this.client_guest.address_factura = resp.data.client.address_f;
      // this.client_guest.point_reference = resp.data.client.point_reference;
      this.ADDRESS = resp.data.client.address;
      this.changeLocation({
        target: {
          value: this.client_guest.departament_factura,
        },
      });
      this.orders_count = resp.data.order_count;
    },
    // --- Helper: toma el carrito local en formato minimal (uniqd / quantity)
    minimalFromLocal() {
      try {
        const raw = localStorage.getItem("carts");
        const arr = Array.isArray(JSON.parse(raw)) ? JSON.parse(raw) : [];
        return arr
          .filter((x) => x && x.uniqd)
          .map((x) => ({
            uniqd: String(x.uniqd),
            quantity: Math.max(1, Number(x.quantity || 1)),
          }));
      } catch {
        return [];
      }
    },

    // --- Helper: sincroniza header y storage después de autenticar
    async syncAfterAuth() {
      try {
        const resp = await myApi.get("ecommerce/carts/");
        const rows = resp?.data?.carts?.data || [];

        // snapshot minimal desde servidor (verdad oficial)
        const MIN = rows.map((r) => ({
          uniqd: String(r?.product?.uniqd ?? r?.uniqd),
          quantity: Math.max(1, Number(r?.quantity || 1)),
        }));

        // actualiza localStorage para evitar drift
        localStorage.setItem("carts", JSON.stringify(MIN));

        // alinear header (mini-carrito)
        if (this.emitter?.emit) {
          this.emitter.emit("cart-shop", {
            items: MIN,
            replace: true,
            source: "server",
          });
        }
      } catch (e) {
        // silencioso para no romper el flujo de checkout
        if (process.env.NODE_ENV !== "production")
          console.warn("syncAfterAuth", e);
      }
    },

    // ----------------- LOGIN -----------------
    guestMinimal() {
      try {
        const raw = localStorage.getItem("carts");
        const arr = Array.isArray(JSON.parse(raw)) ? JSON.parse(raw) : [];
        return arr
          .filter((x) => x && x.uniqd)
          .map((x) => ({
            uniqd: String(x.uniqd),
            quantity: Number(x.quantity || 1),
          }));
      } catch {
        return [];
      }
    },

    async Login() {
      try {
        if (!this.email_login || !this.password_login) {
          this.$notify({
            title: "VALIDACIÓN",
            text: "SE DEBE INGRESAR TODOS LOS CAMPOS PARA PODER INGRESAR A LA TIENDA!",
            duration: 3500,
            type: "error",
          });
          return;
        }

        this.loading = true;
        const payload = {
          email: this.email_login,
          password: this.password_login,
          CART: [],
          executeRecaptcha: this.executeRecaptcha,
        };

        // Si envías el carrito, manda minimal (opcional y seguro).
        // const minimalCart = Array.isArray(this.CARTS)
        //     ? this.CARTS.filter(x => x && x.uniqd).map(x => ({
        //         uniqd: String(x.uniqd),
        //         quantity: Number(x.quantity || 1),
        //     }))
        //     : [];

        // const resp = await myApi.post(
        //     "ecommerce/login",
        //     {
        //         email: this.email_login,
        //         password: this.password_login,
        //         CARTS: minimalCart,
        //     },
        //     // asegúrate que el cookie de sesión se guarde
        //     { withCredentials: true }
        // );
        await store.dispatch("login", payload);
        await store.commit("setPerfilQuery", null);
        const respCar = await myApi.get("ecommerce/carts/");
        const rows = respCar?.data?.carts?.data || [];
        const minimal = rows.map((r) => ({
          id: r?.id,
          uniqd: String(r?.product?.uniqd ?? r?.uniqd),
          quantity: Math.max(1, Number(r?.quantity || 1)),
        }));
        await this.processCartSucursal(minimal);
        await this.showProfile();
        // 4) Refrescar header/mini-carrito desde servidor (sesión ya establecida por cookie)
        //    Tu Header tiene un listener que re-sincroniza el carrito cuando recibe 'refres-cart-list'
        //    y también levanta “la verdad oficial” desde ecommerce/carts/ (ver listCarts). :contentReference[oaicite:0]{index=0}
        this.emitter?.emit?.("refres-cart-list", {});

        // 5) Avanzar UI del checkout sin recargar toda la página
        this.loggedIn = true;
        this.type_nav = 2; // pasas a la sección de datos/envío
        this.hydrateClientFromUser?.(); // rellena email/teléfono desde el user
        this.$notify({
          title: "Bienvenido",
          text: "Sesión iniciada.",
          type: "success",
          duration: 1200,
        });
      } catch (err) {
        const data = err?.response?.data;

        if (err?.response?.status === 423) {
          // Guarda credenciales para auto-login después del OTP
          sessionStorage.setItem(
            "pendingLogin",
            JSON.stringify({
              email: this.email,
              password: this.password,
            })
          );

          this.$router.push({
            name: "OtpValidate",
            query: { email: this.email },
          });
          return;
        }

        if (data?.error) {
          Object.values(data.error)
            .flat()
            .forEach((msg) => {
              this.$notify({
                title: "VALIDACIÓN",
                text: msg,
                duration: 3500,
                type: "error",
              });
            });
          return;
        }

        this.$notify({
          title: "VALIDACIÓN",
          text:
            data?.message ||
            "Hubo un error al iniciar sesión, inténtalo nuevamente",
          duration: 3500,
          type: "error",
        });
      } finally {
        this.loading = false;
      }
    },

    // --------------- REGISTER ----------------
    // Reemplaza tu función Register() existente con esta:

    async Register() {
      try {
        // 1. Validaciones iniciales
        if (
          !this.email_register ||
          !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(this.email_register)
        ) {
          this.$notify({
            title: "VALIDACIÓN",
            text: "Ingresa un correo electrónico válido.",
            duration: 3500,
            type: "error",
          });
          return;
        }
        if (
          !this.name_register ||
          !this.surname_register ||
          !this.password_register
        ) {
          this.$notify({
            title: "VALIDACIÓN",
            text: "Completa todos los campos requeridos.",
            duration: 3000,
            type: "error",
          });
          return;
        }

        this.loading = true;
//SE IMPLEMENTO LA VALIDACION DE EMAIL REPUTATION DESDE EL BACKEND PERO EL CLIENTE SOLO PAGO EL PLANBASICO Y SE TERMINO LOS TOKENS DE LA API
        // // 2. Verificación de reputación de correo
        // const rep = await checkEmailReputation(this.email_register, {
        //   blockOnError: true,
        // });
        // if (!rep.ok) {
        //   this.$notify({
        //     title: "Correo no válido",
        //     text: "El correo parece desechable o tiene mala reputación. Por favor, usa otro.",
        //     duration: 4500,
        //     type: "error",
        //   });
        //   this.loading = false;
        //   return;
        // }

        // 3. Construcción del payload
        // const payload = {
        //     surname: this.surname_register,
        //     name: this.name_register,
        //     email: this.email_register,
        //     password: this.password_register,
        //     CARTS: this.CARTS?.length ? this.CARTS.map(c => ({ uniqd: String(c.uniqd), quantity: Number(c.quantity || 1) })) : this.minimalFromLocal(),
        // };

        // 4. Solicitud de OTP (en lugar de registrar directamente)
        // Nota: Asumo que tu backend en 'ecommerce/register' ahora maneja la solicitud de OTP.
        // Si tienes un endpoint separado como 'request-otp', úsalo aquí.
        // await myApi.post('ecommerce/register', payload);
        await recaptchaPost(
          this.executeRecaptcha,
          "register",
          "ecommerce/register",
          {
            surname: this.surname_register,
            name: this.name_register,
            email: this.email_register,
            password: this.password_register,
          }
        );

        // 5. Mostrar el formulario OTP
        this.$notify({
          title: "Verificación requerida",
          text: "Te hemos enviado un código a tu correo.",
          duration: 3500,
          type: "primary",
        });
        this.showOtpInput = true;
        this.startTimer(600);
      } catch (err) {
        const msg =
          err?.response?.data?.error?.email?.[0] ||
          err?.response?.data?.message ||
          "Hubo un error al procesar el registro.";
        this.$notify({
          title: "ERROR",
          text: msg,
          duration: 3500,
          type: "error",
        });
      } finally {
        this.loading = false;
      }
    },

    // Dentro de tu `methods` en NewCheckout.vue

    // --- MÉTODOS DE SANITIZACIÓN ---
    onlyStringVarcharN() {
      // Para el campo "Nombres"
      const regex = /[^A-Za-záéíóúÁÉÍÓÚñÑ\s]/g;
      if (this.name_register && regex.test(this.name_register)) {
        this.name_register = this.name_register.replace(regex, "");
      }
    },
    onlyStringVarcharS() {
      // Para el campo "Apellidos"
      const regex = /[^A-Za-záéíóúÁÉÍÓÚñÑ\s]/g;
      if (this.surname_register && regex.test(this.surname_register)) {
        this.surname_register = this.surname_register.replace(regex, "");
      }
    },
    allowEmailKeypress(e) {
      const key = e.key;
      const controlKeys = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
        "Enter",
      ];
      if (controlKeys.includes(key)) return;
      if (!this.emailAllowedRegex.test(key)) return e.preventDefault();
      if (key === "@" && (this.email_register || "").includes("@"))
        e.preventDefault();
    },
    handleEmailPaste(e) {
      const text =
        (e.clipboardData || window.clipboardData).getData("text") || "";
      this.email_register = this.normalizeEmail(text);
    },
    sanitizeEmailOnInput(e) {
      const value = e.target.value || "";
      const sanitized = this.normalizeEmail(value);
      if (sanitized !== value) this.email_register = sanitized;
    },
    normalizeEmail(text) {
      let cleaned = text
        .replace(/\s+/g, "")
        .replace(/['"`<>()[\]{};:\\/|^%$#!?,=~]/g, "")
        .split("")
        .filter((ch) => this.emailAllowedRegex.test(ch))
        .join("");

      const firstAt = cleaned.indexOf("@");
      if (firstAt !== -1) {
        const before = cleaned.slice(0, firstAt + 1);
        const after = cleaned.slice(firstAt + 1).replace(/@/g, "");
        cleaned = before + after;
      }
      return cleaned;
    },

    // MAPAS
    initializeMap(lat, lng) {
      const mapContainer = this.$refs.googleMap;

      if (this.google) {
        this.map = new this.google.maps.Map(mapContainer, {
          center: { lat: lat, lng: lng },
          gestureHandling: "greedy",
          zoom: 16,
        });
        const icon2 = {
          url: "/assets/logos/servicio-al-cliente.png", // Ruta de tu icono personalizado
          scaledSize: new this.google.maps.Size(50, 50), // Tamaño del icono
        };
        this.marker = new this.google.maps.Marker({
          position: {
            lat: lat,
            lng: lng,
          },
          map: this.map,
          title: "Latitude:" + 0 + " | Longitude:" + 0,
          icon: icon2,
        });

        var result = {
          lat: lat,
          lng: lng,
        };
        var geocoder = new this.google.maps.Geocoder();
        geocoder.geocode({ location: result }, (results, status) => {
          if (status === "OK") {
            if (results[0]) {
              if (!this.ADDRES_SELECTED) {
                this.client_guest.address = results[0].formatted_address;
                let ARRAY_TEXT = this.client_guest.address.split(",");
                if (ARRAY_TEXT.length > 2) {
                  this.changeForMunicipio(ARRAY_TEXT[ARRAY_TEXT.length - 2]);
                }
              }
            } else {
              window.alert("No results found");
            }
          } else {
            window.alert("Geocoder failed due to: " + status);
          }
        });

        this.map.addListener("click", (mapsMouseEvent) => {
          let lat = Number(mapsMouseEvent.latLng.lat().toString());
          let lng = Number(mapsMouseEvent.latLng.lng().toString());

          var result = {
            lat: lat,
            lng: lng,
          };
          // self.validar(lat,lng)
          this.efecto(result);
          this.direccion_correcta = true;
          // this.moveMarker();

          var geocoder = new this.google.maps.Geocoder();
          // var self = this;
          geocoder.geocode({ location: result }, (results, status) => {
            if (status === "OK") {
              if (results[0]) {
                // infowindow.setContent();
                // console.log(results[0].formatted_address);
                if (!this.ADDRES_SELECTED) {
                  this.client_guest.address = results[0].formatted_address;
                  let ARRAY_TEXT = this.client_guest.address.split(",");
                  if (ARRAY_TEXT.length > 2) {
                    this.changeForMunicipio(ARRAY_TEXT[ARRAY_TEXT.length - 2]);
                  }
                }
              } else {
                window.alert("No results found");
              }
            } else {
              window.alert("Geocoder failed due to: " + status);
            }
          });
        });
      } else {
        // this.initGoogleMap();
        // setTimeout(() => {
        //   this.initializeMap(lat, lng);
        // }, 50);
      }
    },
    efecto(result) {
      this.i = 0;
      this.deltaLat = (result.lat - this.latitud) / this.numDeltas;
      this.deltaLng = (result.lng - this.longitud) / this.numDeltas;
      this.moveMarker();
    },
    moveMarker() {
      this.latitud += this.deltaLat;
      this.longitud += this.deltaLng;
      this.client_guest.latitud = this.latitud;
      this.client_guest.longitud = this.longitud;
      this.marker.setTitle(
        "Latitude:" + this.latitud + " | Longitude:" + this.longitud
      );
      this.marker.setPosition({
        lat: this.latitud,
        lng: this.longitud,
      });
      if (this.i !== this.numDeltas) {
        this.i++;
        setTimeout(this.moveMarker(), this.delay);
      }
    },
    async initGoogleMap() {
      //
      const googleMapApi = await GoogleMapsApiLoader({
        apiKey: "AIzaSyA6MRhgLWpKf7XfNNUP3H9yz-ts9R3hvD8",
      });
      this.google = googleMapApi;
      var that = this;
      function onError() {
        that.mapa_error = true;
      }
      function onSuccess(geo) {
        // const position = {
        //     lat: geo.coords.latitude,
        //     lng: geo.coords.longitude
        // };

        // Reposition the map to the detected location
        if (!that.ADDRES_SELECTED) {
          that.latitud = Number(geo.coords.latitude); //13.678767566370581;
          that.longitud = Number(geo.coords.longitude); //-89.27604134734102;
          that.mapa_error = false;
          // that.initializeMap(that.latitud, that.longitud);
        }
        // that.validar(that.latitud,that.longitud)
      }

      if (!navigator.geolocation) {
        onError();
      } else {
        navigator.geolocation.getCurrentPosition(onSuccess, onError);
      }
      // this.obtener_direcciones();
      // this.initializeMap(this.latitud,this.longitud);
    },
    async SaveAddress() {
      try {
        if (
          !this.client_guest.departament ||
          !this.client_guest.municipality ||
          !this.client_guest.address ||
          !this.title
        ) {
          this.$notify({
            title: "VALIDACIÓN",
            text: "PARA REGISTRAR UNA DIRECCIÓN TODAS LOS CAMPOS SON NECESARIOS",
            duration: 3500,
            type: "error",
          });
          return;
        }
        let data = {
          title: this.title,
          latitud: this.latitud,
          longitud: this.longitud,
          departament: this.client_guest.departament,
          municipality: this.client_guest.municipality,
          address: this.client_guest.address,
          point_reference: this.client_guest.point_reference,
        };
        const resp = await myApi.post("ecommerce/profile_address", data);

        this.ADDRESS.push(resp.data.address);
        setTimeout(() => {
          this.changeAddress({ target: { value: resp.data.address.id } });
        }, 25);
        this.$notify({
          title: "REGISTRO DE DIRECCIÓN",
          text: "SE AGREGO UNA NUEVA DIRECCIÓN A SU PANEL",
          duration: 3500,
          type: "primary",
        });
        this.departament = null;
        this.municipality = null;
        this.address = null;
        this.point_reference = null;
        this.title = null;
      } catch (error) {
        console.log(error);
        this.$notify({
          title:
            "Hubo un error a nivel interno, comuniquese con el soporte de la pagina",
          duration: 3500,
          type: "error",
        });
      }
    },
    changeLocation(event) {
      let MUNICIPIO_SELECTED = event.target.value;
      let MUNUCIPIOS = this.BACKUP_MUNICIPIOS.filter(
        (item) => item.state == MUNICIPIO_SELECTED
      );
      this.S_MUNICIPIOS = MUNUCIPIOS;
    },
    changeForMunicipio(municipio) {
      let DEPARTAMENTO = this.BACKUP_MUNICIPIOS.filter(
        (item) => item.city == municipio.trim()
      );
      // console.log(DEPARTAMENTO,municipio);
      if (DEPARTAMENTO.length > 0) {
        this.client_guest.departament = DEPARTAMENTO[0].state;
        this.client_guest.municipality = municipio.trim();
        this.changeLocation({ target: { value: DEPARTAMENTO[0].state } });
      }
    },
    changeAddress(event) {
      let ADDRESS_SELECTED = event.target.value;
      if (!ADDRESS_SELECTED) {
        //
        this.title = null;
        this.client_guest.departament = null;
        this.client_guest.municipality = null;
        this.client_guest.address = null;
        this.client_guest.point_reference = null;
        this.client_guest.latitud = null;
        this.client_guest.longitud = null;
        //
        this.ADDRES_SELECTED = null;
        this.OPTION_SELECTED = false;
        // setTimeout(() => {
        //     this.initGoogleMap();
        // }, 50);
        return;
      }
      this.OPTION_SELECTED = true;
      this.ADDRES_SELECTED = ADDRESS_SELECTED;
      let ADDRE = this.ADDRESS.find((item) => item.id == ADDRESS_SELECTED);
      this.client_guest.departament = ADDRE.departament;
      this.client_guest.municipality = ADDRE.municipality;
      this.client_guest.address = ADDRE.address;
      this.client_guest.point_reference = ADDRE.point_reference;
      this.client_guest.latitud = ADDRE.latitud;
      this.client_guest.longitud = ADDRE.longitud;

      this.changeLocation({
        target: {
          value: ADDRE.departament,
        },
      });
      if (this.loggedIn) {
        // this.initGoogleMap();
      }
      setTimeout(() => {
        if (ADDRE.latitud) {
          this.latitud = Number(ADDRE.latitud);
          this.longitud = Number(ADDRE.longitud);
          // this.initializeMap(this.latitud, this.longitud);
        }
      }, 50);
    },
    selectedAddress(ADDRE) {
      this.client_guest.departament = ADDRE.departament;
      this.client_guest.municipality = ADDRE.municipality;
      this.client_guest.address = ADDRE.address;
      this.client_guest.point_reference = ADDRE.point_reference;
      this.client_guest.latitud = ADDRE.latitud;
      this.client_guest.longitud = ADDRE.longitud;

      this.changeLocation({
        target: {
          value: ADDRE.departament,
        },
      });

      setTimeout(() => {
        if (ADDRE.latitud) {
          this.latitud = Number(ADDRE.latitud);
          this.longitud = Number(ADDRE.longitud);
          // this.initializeMap(this.latitud, this.longitud);
        }
      }, 50);
    },
    resetAddress() {
      this.OPTION_SELECTED = true;
      //
      this.title = null;
      this.client_guest.departament = null;
      this.client_guest.municipality = null;
      this.client_guest.address = null;
      this.client_guest.point_reference = null;
      this.client_guest.latitud = null;
      this.client_guest.longitud = null;
      //
      // this.initGoogleMap();
    },
    /**
     * Sanitiza una entrada para prevenir XSS y otras vulnerabilidades
     * @param {any} value - Valor a sanitizar
     * @returns {any} - Valor sanitizado o el valor original si es null/undefined
     */
    sanitizeInput(value) {
      // Si es null o undefined, devolver tal cual
      if (value === null || value === undefined) return value;

      // Convertir a string
      const strValue = String(value);

      // Eliminar tags HTML y caracteres potencialmente peligrosos
      return strValue
        .replace(/<\/?[^>]+(>|$)/g, "") // Elimina tags HTML
        .replace(/[<>"'`;]/g, ""); // Elimina caracteres especiales peligrosos
    },
    /**
     * Sanitiza todos los datos del formulario
     * Se llama antes de enviar datos al servidor
     */
    sanitizeFormData() {
      // Sanitizar objeto client_guest
      if (this.client_guest) {
        Object.keys(this.client_guest).forEach((key) => {
          if (
            this.client_guest[key] !== null &&
            this.client_guest[key] !== undefined
          ) {
            this.client_guest[key] = this.sanitizeInput(this.client_guest[key]);
          }
        });
      }

      // Sanitizar objeto delivery_information
      if (this.delivery_information) {
        Object.keys(this.delivery_information).forEach((key) => {
          if (
            this.delivery_information[key] !== null &&
            this.delivery_information[key] !== undefined &&
            typeof this.delivery_information[key] !== "object"
          ) {
            this.delivery_information[key] = this.sanitizeInput(
              this.delivery_information[key]
            );
          }
        });
      }

      // Sanitizar objeto payment_info
      if (this.payment_info) {
        Object.keys(this.payment_info).forEach((key) => {
          if (
            this.payment_info[key] !== null &&
            this.payment_info[key] !== undefined
          ) {
            this.payment_info[key] = this.sanitizeInput(this.payment_info[key]);
          }
        });
      }

      // Sanitizar campos de login y registro
      // Solo sanitizamos si están definidos (pueden no estarlo si el usuario está usando otro método)
      const authFields = [
        "email_login",
        "password_login",
        "name_register",
        "surname_register",
        "email_register",
        "password_register",
      ];
      authFields.forEach((field) => {
        if (this[field] !== undefined) {
          this[field] = this.sanitizeInput(this[field]);
        }
      });
    },

    /**
     * Sanitiza cualquier campo en tiempo real
     * @param {Event} event - Evento del input
     * @param {string} field - Nombre del campo (puede ser de client_guest o del componente)
     */
    sanitizeField(event, field) {
      // Primero intentamos sanitizar como propiedad de client_guest
      if (field.includes(".")) {
        // Si el campo tiene un punto, es una propiedad anidada (ej: 'client_guest.phone')
        const [obj, prop] = field.split(".");
        if (this[obj] && this[obj][prop] !== undefined) {
          this[obj][prop] = this.sanitizeInput(event.target.value);
        }
      } else if (this.client_guest && this.client_guest[field] !== undefined) {
        // Es una propiedad de client_guest
        this.client_guest[field] = this.sanitizeInput(event.target.value);
      } else if (this[field] !== undefined) {
        // Es una propiedad del componente Vue
        this[field] = this.sanitizeInput(event.target.value);
      }
    },

    /**
     * Combina sanitización con la función applyMask para DUI
     * @param {Event} event - Evento de input
     */
    sanitizeAndApplyMask(event) {
      // Primero sanitizamos el valor
      const sanitized = this.sanitizeInput(event.target.value);

      // Actualizamos el valor sanitizado
      this.client_guest.dui = sanitized;

      // Luego llamamos a la función original de máscara
      this.applyMask();
    },

    /**
     * Combina sanitización con la función updateMaskNit
     * @param {Event} event - Evento de input
     */
    sanitizeAndUpdateMaskNit(event) {
      // Primero sanitizamos el valor
      const sanitized = this.sanitizeInput(event.target.value);

      // Actualizamos el valor sanitizado
      this.client_guest.nit = sanitized;

      // Luego llamamos a la función original de máscara
      this.updateMaskNit();
    },

    /**
     * Combina sanitización con la función updateMaskNrc
     * @param {Event} event - Evento de input
     */
    sanitizeAndUpdateMaskNrc(event) {
      // Primero sanitizamos el valor
      const sanitized = this.sanitizeInput(event.target.value);

      // Actualizamos el valor sanitizado
      this.client_guest.nrc = sanitized;

      // Luego llamamos a la función original de máscara
      this.updateMaskNrc();
    },
    //
    selectedTypeEntrega(val) {
      this.type_entrega = val;
      //
      this.client_guest.departament = null;
      this.client_guest.municipality = null;
      this.client_guest.address = null;
      this.client_guest.point_reference = null;
      this.client_guest.latitud = null;
      this.client_guest.longitud = null;
      //
      this.ADDRES_SELECTED = null;
      this.OPTION_SELECTED = false;
      //
      this.delivery_information.sucursal = null;
      //
      if (!this.loggedIn) {
        // this.initGoogleMap();
      }
      // this.initGoogleMap();
    },
    //
    async storeOrder(transactionData = null) {
      // La sanitización ya se realizó en tiempo real, no es necesario hacerlo nuevamente
      // this.client_guest
      // this.delivery_information
      // this.payment_info
      // this.photo_file

      if (this.type_payment == 1) {
        if (!this.type_cuenta_bancaria) {
          this.$notify({
            title: "VALIDACIÓN",
            text: `Necesitas seleccionar una cuenta bancaria`,
            duration: 3500,
            type: "error",
          });
          return;
        }
        const totalAPagar = Number(
          (
            Number(this.TOTAL_SUM) + (this.isTaxP() ? Number(this.tax) : 0)
          ).toFixed(2)
        );
        if (this.payment_info.amount !== totalAPagar) {
          this.$notify({
            title: "VALIDACIÓN",
            text: `El monto del pago (${this.payment_info.amount}) no coincide con el total a pagar (${totalAPagar}).`,
            duration: 3500,
            type: "error",
          });
          return;
        }
        if (!this.payment_info.account_holder) {
          this.$notify({
            title: "VALIDACIÓN",
            text: `Necesitas digitar al titular de la cuenta`,
            duration: 3500,
            type: "error",
          });
          return;
        }
        // if(!this.payment_info.concept){
        //     this.$notify({
        //         title: "VALIDACIÓN",
        //         text: `Necesitas ingresar por concepto de la cuenta`,
        //         duration: 3500,
        //         type:'error',
        //     });
        //     return;
        // }
        if (!this.payment_info.reference_number) {
          this.$notify({
            title: "VALIDACIÓN",
            text: `Necesitas ingresar por número de referencia`,
            duration: 3500,
            type: "error",
          });
          return;
        }
        if (!this.payment_info.amount) {
          this.$notify({
            title: "VALIDACIÓN",
            text: `Necesitas ingresar el monto del deposito`,
            duration: 3500,
            type: "error",
          });
          return;
        }
        if (!this.photo_file) {
          this.$notify({
            title: "VALIDACIÓN",
            text: `Necesitas ingresar el comprobante del deposito`,
            duration: 3500,
            type: "error",
          });
          return;
        }
      }
      if (this.type_payment == 4) {
        //  if(!this.amount_efectivo_contra_entrega && this.tp_pay_contra_entrega == 1){
        // this.$notify({
        //  title: "VALIDACIÓN",
        //  text: `Necesitas ingresar un CAMBIO POR`,
        //  duration: 3500,
        //   type:'error',
        //  });
        // return;
        // }
      }
      if (this.type_payment == 4) {
        const totalAPagar = Number(
          (
            Number(this.TOTAL_SUM) + (this.isTaxP() ? Number(this.tax) : 0)
          ).toFixed(2)
        );
        const cambioIngresado = Number(this.amount_efectivo_contra_entrega);

        if ((cambioIngresado <= totalAPagar) & (cambioIngresado !== 0)) {
          this.$notify({
            title: "VALIDACIÓN",
            text: `El monto para cambio ($${cambioIngresado.toFixed(
              2
            )}) debe ser mayor al total a pagar ($${totalAPagar.toFixed(2)})`,
            duration: 3500,
            type: "error",
          });
          return;
        }
      }

      let formData = new FormData();
      if (this.client_guest) {
        formData.append("client_guest", JSON.stringify(this.client_guest));
      }
      formData.append(
        "delivery_information",
        JSON.stringify(this.delivery_information)
      );
      if (this.token_card) {
        formData.append("token_card", this.token_card);
      } else {
        if (this.type_payment != 4) {
          this.payment_info.type_cuenta_bancaria = this.type_cuenta_bancaria;
          formData.append("payment_info", JSON.stringify(this.payment_info));
          formData.append("photo_file", this.photo_file);
        }
      }
      if (this.resultado_fac) {
        formData.append("resultado_fac", JSON.stringify(this.resultado_fac));
      }
      formData.append("order_details", JSON.stringify(this.CARTS));

      // Si hay datos de transacción BAC o Serfinsa, agregarlos al formulario
      if (transactionData) {
        formData.append("transaction_data", JSON.stringify(transactionData));

        // Si es una transacción de Serfinsa, enviar el identificador de transacción
        if (transactionData.serfinsa_identifier) {
          formData.append(
            "serfinsa_identifier",
            transactionData.serfinsa_identifier
          );
        }
      }

      try {
        let order = {
          is_credito_fiscal: this.is_credito_fiscal,
          type_entrega: this.type_entrega,
          type_payment: this.type_payment,
          sucursal: this.delivery_information.sucursal,
          // estimated_at: null,
          sel_type_pay: this.selTypePay(),
          sel_type_pay_cuotas: this.selTypePayCuotas(),
          is_visa_master: this.is_visa ? this.is_visa : null,
          // received_at: null,
          tax: this.isTaxP() ? this.tax : 0,
          paypalAmountLegacy: this.paypalAmountLegacy(),
          // code: ,
          discount: 0,
          subtotal: this.TOTAL_SUM.toFixed(2),
          total: (
            this.TOTAL_SUM +
            (this.isTaxP() ? this.tax : 0) +
            this.paypalAmountLegacy()
          ).toFixed(2),
        };

        if (this.type_payment == 4) {
          order.tp_pay_contra_entrega = this.type_payment_contra_entrega;
          order.amount_efect_contra_entrega =
            this.amount_efectivo_contra_entrega;
          order.type_payment_card = this.type_payment_card;
        }

        formData.append("order", JSON.stringify(order));
        this.loading = true;
        const resp = await myApi.post("ecommerce/order", formData);

        this.loading = false;
        if (resp.data.error) {
          for (let key in resp.data.error) {
            this.$notify({
              title: "VALIDACIÓN",
              text: resp.data.error[key],
              duration: 3500,
              type: "error",
            });
          }
        } else {
          // this.$cookies.set("carts", []);
          // this.emitter.emit("cart-shop", []);
          if (resp.data.message == 403) {
            resp.data.errors.forEach((elem) => {
              this.$notify({
                title: "VALIDACIÓN",
                text: elem,
                duration: 3500,
                type: "error",
              });
            });
          } else {
            // this.$cookies.remove("carts");

            let arrayProd = [];
            let totalAmount = 0;

            let itemsProd = localStorage.getItem("carts")
              ? JSON.parse(localStorage.getItem("carts"))
              : [];

            itemsProd?.map((item) => {
              arrayProd.push(item.id);
              totalAmount += item.total;
            });

            window.fbq("track", "Purchase", {
              content_ids: arrayProd, // 'REQUIRED': array of product IDs
              value: totalAmount.toFixed(2), // REQUIRED, up to 2 decimals optional
              currency: "USD", // REQUIRED
              content_type: "product", // RECOMMENDED: Either product or product_group based on the content_ids or contents being passed.
            });
            //    if (this.type_payment !== 3 && this.loggedIn ) {
            //     await Promise.all(
            //     this.CARTS.map(item =>
            //     myApi.post(`ecommerce/carts/delete/${item.id}`)
            //     )
            //     );
            //     }

            localStorage.removeItem("carts");
            this.$router.replace({
              name: "OrderSuccess",
              params: {
                uniqd: resp.data.uniqd_order,
              },
            });
            this.token_card = null;
            this.$notify({
              title: "PROCESO DE COMPRA",
              text: `LA COMPRA SE REALIZO EXITOSAMENTE`,
              duration: 2000,
            });
          }
        }
      } catch (error) {
        this.loading = false;
        console.log("order", error);
        this.$notify({
            title: `${error?.response?.data?.message_text ?? 'Ocurrió un problema inesperado. Por favor, inténtalo de nuevo en un par de minutos :)'}`,
            duration: 3500,
            type: 'error',
        });
      }
    },
    selTypePay() {
      if (this.type_payment == 2) {
        return this.selected_type_pay;
      }
      return null;
    },
    selTypePayCuotas() {
      if (this.type_payment == 2) {
        return this.selected_type_pay == 2
          ? this.selected_type_pay_cuotas
          : null;
      }
      return null;
    },
    //
    isTaxP() {
      if (this.type_entrega == 2) {
        // if(this.client_guest.departament == "San Salvador" || this.client_guest.departament == "La Libertad"){
        //     if(this.client_guest.municipality == "San Salvador" || this.client_guest.municipality == "Santa Tecla"){
        //         return false;
        //     }
        // }
        if (this.is_free == 2) {
          return false;
        }
        return true;
      }
      return false;
    },
    paypalAmountLegacy() {
      if (this.type_payment == 3) {
        return (this.TOTAL_SUM + (this.isTaxP() ? this.tax : 0)) * 0.056 + 0.35;
      }
      return 0;
    },
    //
    validateFile(fileInput) {
      const allowedExtensions = /\.(jpg|jpeg|png|webp|pdf)$/i; // Extensiones permitidas en regex
      const maxSizeInBytes = 5 * 1024 * 1024; // 5 MB en bytes

      if (!fileInput.files || fileInput.files.length === 0) {
        return false; // No se seleccionó ningún archivo
      }

      const file = fileInput.files[0];

      if (!allowedExtensions.test(file.name)) {
        return false; // La extensión del archivo no es válida
      }

      if (file.size > maxSizeInBytes) {
        return false; // El archivo supera el tamaño máximo permitido
      }

      return true; // El archivo cumple con todas las condiciones
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      if (!this.validateFile(e.target)) {
        this.$notify({
          title:
            "Solo se permite estas extesiones (jpg, png, webp y pdf) y un peso maximo de 5MB.",
          duration: 4000,
          type: "error",
        });
        e.target.value = "";
        this.photo_file = null;
        return;
      }
      this.photo_file = files[0];
    },
    async procesarPago() {
      try {
        // Verificar aceptación de términos y condiciones
        if (!this.acepte_terminos) {
          this.$notify({
            title: "Necesitas primero aceptar nuestros términos y condiciones",
            duration: 3500,
            type: "error",
          });
          return;
        }

        if (this.isWompi) {
          await this.pagarConWompiEnlace();
          return;
        }
        // Si es pago en efectivo o contra entrega
        if (this.type_payment == 1 || this.type_payment == 4) {
          this.storeOrder();
          return;
        }

        // Si es pago con tarjeta, validar campos
        if (
          !this.number_card ||
          !this.cvv_card ||
          !this.full_name_card ||
          !this.month_card ||
          !this.year_card
        ) {
          this.$notify({
            title:
              "Debes llenar toda la información solicitada para procesar el pago con tarjeta",
            duration: 3500,
            type: "error",
          });
          return;
        }

        // Si es pago a plazos con Banco Agrícola
        if (this.selected_type_pay === 2 && this.selected_bank === "agricola") {
          await this.processWompiCuotas();
          return;
        }

        // Si es pago con BAC (PowerTranz) - tanto normal como a plazos
        if (this.selected_bank === "bac") {
          // Pago normal (un solo pago)
          if (this.selected_type_pay === 1) {
            await this.processBacPayment(1, 0); // Pago normal
            return;
          }
          // Pago a plazos
          else if (this.selected_type_pay === 2) {
            // Verificar que se haya seleccionado un número de cuotas
            if (!this.selected_type_pay_cuotas) {
              this.$notify({
                title: "Selección de cuotas requerida",
                text: "Por favor seleccione el número de cuotas para continuar con el pago a plazos.",
                duration: 3500,
                type: "warning",
              });
              return;
            }

            await this.processBacPayment(2, this.selected_type_pay_cuotas);
            return;
          }
        }

        // Para otros tipos de pago con tarjeta no soportados
        this.$notify({
          title: "Método de pago no soportado",
          text: "Por favor seleccione un método de pago válido (BAC o Banco Agrícola).",
          duration: 5000,
          type: "warning",
        });
      } catch (error) {
        console.error("Error al procesar el pago:", error);
        this.WARNING_TEXT =
          "Ocurrió un error al procesar el pago. Por favor, intente nuevamente.";
        this.loading = false;
      }
    },
    async selectedTypeSucursal(sucursal) {
      this.delivery_information.sucursal = sucursal;
    },
    selectedTypeCuentaBancaria(val) {
      console.log("data bancaria", val);
      this.type_cuenta_bancaria = val;
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isStringT(evt) {
      // console.log(evt);
      if (evt.key == " " || evt.key.match(/^[A-Za-z]*$/)) {
        return true;
      } else {
        evt.preventDefault();
      }
    },
    isStringAlfaNumer(evt) {
      // console.log(evt);
      // var valor = evt.target.value;
      // // Elimina todos los caracteres que no sean alfanuméricos
      // var valorLimpio = valor.replace(/[^a-zA-Z0-9]/g, '');
      // // Actualiza el valor del input con el valor limpio
      // evt.target.value = valorLimpio;evt.key == ' ' ||
      if (evt.key.match(/^[^a-zA-Z0-9\s]*$/)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    handlePaste(event, type) {
      event.preventDefault();
      const pastedText = (event.clipboardData || window.clipboardData).getData(
        "text"
      );

      switch (type) {
        case "numberCard": {
          this.digitalCard(pastedText);
          break;
        }
        case "nameCard": {
          const sanitizedName = this.sanitizeInput(pastedText);
          this.full_name_card = sanitizedName;
          // También actualizar el valor del input
          event.target.value = sanitizedName;
          break;
        }
        default: {
          return this.sanitizeInput(pastedText);
        }
      }
    },

    digitalCard(valor) {
      if (valor) {
        let TEXTS = valor.replace(/[^\d]/g, "");
        TEXTS = TEXTS.slice(0, 16);

        let FIRST_LETER = TEXTS.charAt(0);
        if (FIRST_LETER == "4") {
          this.is_visa = 1;
        } else if (FIRST_LETER == "5") {
          this.is_visa = 2;
        } else if (FIRST_LETER == "3") {
          this.is_visa = 3;
        } else {
          this.is_visa = null;
        }
        var valorFormateado = "";
        for (var i = 0; i < TEXTS.length; i++) {
          if (i > 0 && i % 4 === 0) {
            valorFormateado += " ";
          }
          valorFormateado += TEXTS[i];
        }
        this.number_card = valorFormateado;
      } else {
        this.is_visa = null;
        this.number_card = "";
      }
    },
    cvvCard(valor) {
      this.cvv_card = valor;
      this.cvv_card = this.cvv_card.replace(/\D/g, "");
      this.limitarDigitos(4); // Limitar a 3 o 4 dígitos para CVC
    },
    limitarDigitos(maxDigitos = 4) {
      var valor = this.cvv_card;
      if (valor.length > maxDigitos) {
        valor = valor.slice(0, maxDigitos);
        this.cvv_card = valor;
      }
    },
    fullNameCard(valor) {
      this.full_name_card = valor;
    },
    MonthCard(valor) {
      this.month_card = valor;
    },
    YearCard(valor) {
      this.year_card = valor;
    },
    nextInfoDelivery() {
      this.PHONE_ERROR_TEXT = null;
      // if(!this.client_guest.departament_factura || !this.client_guest.municipality_factura || !this.client_guest.address_factura){
      //     // this.$notify({
      //     //     title: "VALIDACIÓN",
      //     //     text: `SE DEBE INGRESAR TODOS LOS CAMPOS DE LA DIRECCIÓN DE FACTURACIÓN!`,
      //     //     duration: 3500,
      //     //     type:'error',
      //     // });
      //     this.PHONE_ERROR_TEXT = "Se debe ingresar todos los campos de la dirección de facturación!";
      //     if(this.is_credito_fiscal){
      //         if(!this.client_guest.nit || !this.client_guest.nrc || !this.client_guest.giro){
      //             // this.$notify({
      //             //     title: "VALIDACIÓN",
      //             //     text: `LLENAR TODOS LOS CAMPOS DE LA FACTURA DE CREDITO FISCAL`,
      //             //     duration: 3500,
      //             //     type:'error',
      //             // });
      //             this.NIT_NRC_ERROR_TEXT = "Llenar todos los campos de la factura de credito fiscal";
      //             return;
      //         }
      //     }
      //     return;
      // }
      this.priceShoppingCategorie(this.CARTS);
      this.processCartSucursal(this.CARTS);
      if (!/^[^@]+@\w+(\.\w+)+\w$/.test(this.client_guest.email)) {
        this.$notify({
          title: "Ingresa un dirección de correo electronica valida.",
          duration: 3500,
          type: "error",
        });
        return;
      }
      if (!this.client_guest.phone) {
        this.PHONE_ERROR_TEXT = "Debe llenar un telefono de referencia!";
        return;
      }
      if (!this.isPhoneValid()) {
        // this.$notify({
        //     title: "VALIDACIÓN",
        //     text: `EL TELEFONO INGRESADO ES INCORRECTO!`,
        //     duration: 3500,
        //     type:'error',
        // });
        this.PHONE_ERROR_TEXT =
          "El telefono ingresado no tiene el formato correcto!";
        return;
      }
      if (!this.isValidDui(this.client_guest.dui)) {
        this.DUI_ERROR_TEXT =
          "El DUI debe ingresarse y estar en el formato correcto";
        return;
      }
      if (this.is_credito_fiscal) {
        if (!this.isNitValid()) {
          // this.$notify({
          //     title: "VALIDACIÓN",
          //     text: `EL NIT INGRESADO ES INCORRECTO!`,
          //     duration: 3500,
          //     type:'error',
          // });
          this.NIT_NRC_ERROR_TEXT =
            "El NIT ingresado no tiene el formato correcto";
          return;
        }
        if (!this.isNRCValid()) {
          // this.$notify({
          //     title: "VALIDACIÓN",
          //     text: `EL NRC INGRESADO ES INCORRECTO!`,
          //     duration: 3500,
          //     type:'error',
          // });
          this.NIT_NRC_ERROR_TEXT =
            "El NRC ingresado no tiene el formato correcto!";
          return;
        }
      }
      this.type_nav = 3;

      // Initialize Google Map when reaching step 3 if user is not logged in and delivery option is selected
      if (!this.loggedIn && this.type_entrega === 2) {
        // this.initGoogleMap();
      }
    },
    async nextInfoEntrega() {
      if (this.type_entrega == 2) {
        if (
          !this.client_guest.departament ||
          !this.client_guest.municipality ||
          !this.client_guest.address
        ) {
          // this.$notify({
          //     title: "VALIDACIÓN",
          //     text: `SE DEBE INGRESAR TODOS LOS CAMPOS DE LA INFORMACIÓN DE ENTREGA A DOMICILIO!`,
          //     duration: 3500,
          //     type:'error',
          // });
          this.SUCURSAL_ERROR_TEXT =
            "Se debe ingresar todos los campos de la información de entrega a domicilio!";
          return;
        }
        this.priceShoppingZona(this.CARTS);
      } else {
        if (!this.delivery_information.sucursal) {
          // this.$notify({
          //     title: "VALIDACIÓN",
          //     text: `SE DEBE SELECCIONAR UNA SUCURSAL`,
          //     duration: 3500,
          //     type:'error',
          // });
          this.SUCURSAL_ERROR_TEXT = "Tienes que seleccionar una sucursal";
          return;
        }
      }
      // this.modalOpen = false

      this.type_nav = 4;
      if (this.loggedIn) {
        await myApi.post("ecommerce/refresh");
      }
      if (this.type_payment == 2) {
        this.$nextTick(() => {
          const modalEl = document.getElementById("viewDocumentos");
          if (modalEl) {
            // Intentar con Bootstrap global
            if (window.bootstrap) {
              const modal = new window.bootstrap.Modal(modalEl);
              modal.show();
            }
            // Fallback con jQuery si Bootstrap está disponible vía jQuery
            else if (window.$ && window.$.fn.modal) {
              window.$(modalEl).modal("show");
            }
            // Último fallback: usar data-bs-toggle programáticamente
            else {
              modalEl.classList.add("show");
              modalEl.style.display = "block";
              document.body.classList.add("modal-open");

              // Crear backdrop
              const backdrop = document.createElement("div");
              backdrop.className = "modal-backdrop fade show";
              document.body.appendChild(backdrop);
            }
          }
        });
      }
    },
    updateMaskNit() {
      let value = this.client_guest.nit.replace(/\D/g, "");

      if (value.length > 0) {
        let maskedValue = "";

        if (value.length > 4) {
          maskedValue += value.substr(0, 4) + "-";
        } else {
          maskedValue += value;
        }

        if (value.length > 10) {
          maskedValue += value.substr(4, 6) + "-";
        } else {
          maskedValue += value.substr(4);
        }

        if (value.length > 13) {
          maskedValue += value.substr(10, 3) + "-";
        } else {
          maskedValue += value.substr(10);
        }

        if (value.length > 14) {
          maskedValue += value.substr(13, 1);
        } else {
          maskedValue += value.substr(13);
        }

        this.client_guest.nit = maskedValue;
      }
    },
    updateMaskNrc() {
      let value = this.client_guest.nrc.replace(/\D/g, "");

      if (value.length > 0) {
        let maskedValue = "";

        if (value.length > 6) {
          maskedValue += value.substr(0, 6) + "-";
        } else {
          maskedValue += value;
        }

        if (value.length > 7) {
          maskedValue += value.substr(6, 1);
        } else {
          maskedValue += value.substr(6);
        }

        this.client_guest.nrc = maskedValue;
      }
    },
    isPhoneValid() {
      var re = /^[7|6|2][0-9]{7}$/;
      return re.test(this.client_guest.phone);
    },
    isNitValid() {
      var re = /^[0-9]{4}-[0-9]{6}-[0-9]{3}-[0-9]{1}$/;
      return re.test(this.client_guest.nit);
    },
    isNRCValid() {
      var re = /^[0-9]{1,6}-[0-9]{1}$/;
      return re.test(this.client_guest.nrc);
    },
    async priceShoppingCategorie(CARTS = []) {
      const payload = CARTS.map((item) => ({
        quantity: item.quantity,
        uniqd: item.uniqd,
      }));
      const resp = await myApi.post(
        "ecommerce/define_price_shipping_categorie",
        {
          CARTS: payload,
        }
      );

      this.is_free = resp.data.is_free;
      this.tax = resp.data.tax;

      this.getenvioMarcaProd();
    },
    async priceShoppingZona(CARTS = []) {
      const resp = await myApi.post("ecommerce/define_price_shipping_zona", {
        CARTS: CARTS,
        departament: this.client_guest.departament,
        municipio: this.client_guest.municipality,
        TOTAL_SUM: this.TOTAL_SUM,
      });

      if (this.is_free != 2) {
        this.is_free = resp.data.is_free;
      }
      if (this.tax > resp.data.tax) {
        this.tax = resp.data.tax;
      }

      this.getenvioMarcaProd();
    },
    async processCartSucursal(CARTS = []) {
      if (this._updatingCart) return;
      this._updatingCart = true;
      try {
        this.loadingSucursal = null;

        // Usa SIEMPRE la fuente que te pasen (si viene vacía, cae a this.CARTS)
        const source =
          Array.isArray(CARTS) && CARTS.length ? CARTS : this.CARTS;
        const payload = {
          CARTS: source.map((c) => ({
            uniqd: String(c.uniqd),
            quantity: Number(c.quantity ?? 1),
          })),
        };

        const resp = await myApi.post(
          "ecommerce/process_cart_sucursal",
          payload
        );
        this.loadingSucursal = true;

        // Estados especiales
        if (resp.data.message == 500) {
          this.SucursalEmpty = 1;
          this.$notify({
            title: "Hay productos que ya no se pueden procesar...",
            duration: 3500,
            type: "error",
          });
          setTimeout(
            () =>
              this.$router.push({
                name: "CartShop",
                query: { sin_stock: "validar" },
              }),
            1000
          );
          return;
        }
        if (resp.data.message == 403) {
          this.SucursalEmpty = 1;
          this.$notify({
            title: "No se encontró ninguna sucursal disponible",
            duration: 3500,
            type: "error",
          });
          setTimeout(
            () =>
              this.$router.push({
                name: "CartShop",
                query: { sin_stock: "validar" },
              }),
            1000
          );
          return;
        }

        if (resp.data.message == 200) {
          const sucursales = resp.data.sucursales || [];

          //   const contieneWarehouse = sucursales.some(s => s.name === "Warehouse Matrix");

          //     this.sucursal_validate = contieneWarehouse
          //       ? [
          //       {
          //         "name": "Plaza Merliot"
          //       },
          //       {
          //         "name": "San Salvador"
          //       },
          //       {
          //         "name": "Plaza Mundo"
          //       },
          //       {
          //         "name": "San Miguel"
          //       },
          //       {
          //         "name": "Warehouse Matrix"
          //       }
          //     ]
          //       : sucursales;

          this.sucursal_validate = sucursales;

          const precios = resp.data.precios || resp.data.prrecios || [];
          const byId = Object.fromEntries(
            precios.map((p) => [String(p.uniqd ?? p.id_prod), p])
          );

          const normalizeDiscount = (p, basePrice) => {
            const raw = p?.descuento ?? p?.descuneto ?? null;
            if (!raw) return null;

            const percentage = Number(
              raw.percentage ??
                raw?.discount?.percentage ??
                (raw?.discount ? percentage ?? 0 : 0)
            );

            const code =
              raw.code ??
              raw?.discount?.uniqd ??
              raw?.discount_id ??
              raw?.kit_id ??
              0;

            let newAmount = Number(raw.new_amount);
            if (!Number.isFinite(newAmount)) {
              const type = Number(
                raw.type_discount ?? raw?.discount?.type_discount ?? 1
              );
              const disc = Number(
                raw.discount ?? raw?.discount ?? percentage ?? 0
              );
              newAmount =
                type === 1
                  ? basePrice - basePrice * (disc * 0.01)
                  : basePrice - disc;
            }

            return { percentage, new_amount: Number(newAmount), code };
          };

          const newPriceLocal = (Array.isArray(source) ? source : []).map(
            (cart) => {
              const p = byId[String(cart.uniqd)] || {};
              const price = Number(p.precio ?? p.price ?? 0);
              const d = normalizeDiscount(p, price);
              const quantity = Number(cart.quantity) || 1;

              const subtotal = d ? d.new_amount : price;
              return {
                id: cart.id,
                uniqd: cart.uniqd,
                quantity,
                price_unit: Number.isFinite(price) ? price : 0,
                subtotal,
                total: subtotal * quantity,

                // flags para UI (tachado/ahorro)
                type_discount: d ? 1 : 0,
                type_discount_old: d ? 1 : 0,
                discount: d ? d.percentage : 0,
                discount_old: d ? d.percentage : 0,
                code_discount: d ? d.code : 0,
                code_offer: d ? d.code : 0,
              };
            }
          );

          this.CARTS = newPriceLocal;

          // 3) Guardado local: SOLO minimal (no “gordo”)
          const MINIMAL_CART = newPriceLocal.map(({ uniqd, quantity }) => ({
            uniqd,
            quantity,
          }));
          const loginUSer = localStorage.getItem("user");
          if (loginUSer == null) {
            // localStorage.setItem('carts_v2', JSON.stringify(MINIMAL_CART));
            localStorage.setItem("carts", JSON.stringify(MINIMAL_CART)); // compat, también minimal
          } else {
            await myApi.post("ecommerce/update_cart", { cart: MINIMAL_CART });
            if (
              JSON.stringify(MINIMAL_CART) !== JSON.stringify(this._lastMinimal)
            ) {
              this._lastMinimal = MINIMAL_CART;
              this.emitter?.emit?.("refres-cart-list", {});
            }
          }

          // NewCheckout.vue (dentro de processCartSucursal, en el branch message == 200)

          // ...
          this.CARTS = Array.isArray(newPriceLocal) ? newPriceLocal : [];

          // 4) Recalcula totales con guardas
          const list = Array.isArray(this.CARTS) ? this.CARTS : [];
          this.DESCUENTO_TOTAL_SUM = 0;
          this.SUB_TOTAL_SUM = 0;
          this.TOTAL_SUM = list.reduce(
            (sum, c) => sum + Number(c.total || 0),
            0
          );
          list.forEach((c) => {
            if (Number(c.discount) > 0)
              this.DESCUENTO_TOTAL_SUM +=
                Number(c.price_unit || 0) - Number(c.subtotal || 0);
            this.SUB_TOTAL_SUM +=
              Number(c.price_unit || 0) * Number(c.quantity || 1);
          });
        }

        this.loader = false;
      } catch (error) {
        console.log(error);
        this.loadingSucursal = true;
        this.$notify({
          title:
            "Hubo un error a nivel interno, comuniquese con el soporte de la pagina",
          duration: 3500,
          type: "error",
        });
      } finally {
        this._updatingCart = false;
      }
    },

    onApproveR(value) {
      // .purchase_units[0].payments.captures[0].id
      this.resultado_fac = {
        idTransaccion: value.purchase_units[0].payments.captures[0].id,
        esReal: true,
        esAprobada: true,
        codigoAutorizacion: "123456",
        mensaje: "AUTORIZADO DE PAYPAL",
        formaPago: "PagoNormal",
        monto: value.purchase_units[0].amount.value,
      };
      this.$notify({
        text: `TU PAGO SE REALIZO EXITOSAMENTE,AHORA ESTAMOS PROCESADO TU COMPRA`,
        duration: 3000,
      });
      setTimeout(() => {
        this.storeOrder();
      }, 100);
    },
    onErrorR(value) {
      console.log('error pay',value);
      this.$notify({
        title:
          `${value.response.status === 409 ? value?.response?.data?.message_text ?? "TU CUENTA DE PAYPAL ESTA TENIENDO PROBLEMAS PARA PROCESAR EL PAGO, INTENTE CON OTRO METODO DE PAGO"  : "TU CUENTA DE PAYPAL ESTA TENIENDO PROBLEMAS PARA PROCESAR EL PAGO, INTENTE CON OTRO METODO DE PAGO"}`,
        duration: 8500,
        type: "error",
      });
    },
    isDarkLigth() {
      let darkId = localStorage.getItem("darkId")
        ? localStorage.getItem("darkId")
        : "light-btn";
      if (darkId == "light-btn") {
        this.white = null;
        this.dark = true;
      }

      if (darkId == "dark-btn") {
        this.dark = null;
        this.white = true;
      }
    },
    async fetchCart() {
      const respCar = await myApi.get("ecommerce/carts/");
      const rows = respCar?.data?.carts?.data || [];

      const minimal = rows.map((r) => ({
        id: r?.id,
        uniqd: String(r?.product?.uniqd ?? r?.uniqd),
        quantity: Math.max(1, Number(r?.quantity || 1)),
      }));

      return minimal;
    },
    getCartLocalStorage() {
      const minimal = (
        localStorage.getItem("carts")
          ? JSON.parse(localStorage.getItem("carts"))
          : []
      )
        .filter((x) => x && x.uniqd)
        .map((x) => ({
          uniqd: String(x.uniqd),
          quantity: Number(x.quantity || 1),
        }));

      return minimal;
    },
  },
  created() {
    this.isDarkLigth();
  },
  async mounted() {
    window.addEventListener("message", async (ev) => {
      if (!ev || !ev.data || ev.data.src !== "wompi") return;
      const idTransaccion = ev.data.idTransaccion;
      if (!idTransaccion) return;

      this.wompiTx = idTransaccion;

      try {
        const data = await this.verificarTransaccion(idTransaccion);

        if (data?.uniqd) {
          this.procesarPagoExitoso(data);
        } else {
          await this.esperarConfirmacion(idTransaccion);
        }
      } catch (e) {
        this.manejarErrorPago(e);
      }
    });
    // Meta
    this.useMetaT = useMeta({
      title: "Checkout",
      htmlAttrs: { lang: "en", amp: true },
      meta: [],
    });

    // Tema
    this.emitter.on("dark-ligth", () => {
      this.isDarkLigth?.();
    });

    // (Si usas estas constantes)
    this.BACKUP_MUNICIPIOS = SALVADOR.MUNICIPIOS;
    this.S_DEPARTAMENTOS = SALVADOR.DEPARTAMENTOS;
    this.activeTabDelivery = "domicilio";
    this.activeTabPay = "tarjeta";

    if (this.type_entrega === 1) {
      this.activeTabDelivery = "sucursal";
    } else if (this.type_entrega === 2) {
      this.activeTabDelivery = "domicilio";
    }
    if (this.type_payment === 1) {
      this.activeTabPay = "transferencia";
    } else if (this.type_payment === 2) {
      this.activeTabPay = "tarjeta";
    } else if (this.type_payment === 3) {
      this.activeTabPay = "paypal";
    } else if (this.type_payment === 4) {
      this.activeTabPay = "contraentrega";
    }

    // 1) Arranque SIEMPRE con carrito mínimo
    // const min = (localStorage.getItem('carts_v2')
    //     ? JSON.parse(localStorage.getItem('carts_v2'))
    //     : (localStorage.getItem('carts') ? JSON.parse(localStorage.getItem('carts')) : [])
    // ).filter(x => x && x.uniqd).map(x => ({ uniqd: String(x.uniqd), quantity: Number(x.quantity || 1) }));
    // 1) Arranque SIEMPRE con carrito mínimo  const resp = await myApi.get('ecommerce/carts/');

    // 3) Estado de sesión
    this.loggedIn = store.getters.loggedIn;
    if (this.loggedIn) {
      this.showProfile?.();
      this.type_nav = 2;
    }

    if (this.loggedIn) {
      this.hydrateClientFromUser();
    }
    let result = this.loggedIn
      ? await this.fetchCart()
      : await this.getCartLocalStorage();

    //    console.log('min', min)
    this.CARTS = []; // evita flashes; los datos “gordos” llegan desde processCartSucursal
    this.TOTAL_SUM = 0;
    this.SUB_TOTAL_SUM = 0;
    this.DESCUENTO_TOTAL_SUM = 0;

    // 2) Hidrata precios/meta desde el backend usando el minimal
    await this.processCartSucursal(result);

    // 4) Reacciona a cambios de carrito en tiempo real
    this.emitter.on("cart-shop", async (payload) => {
      // payload puede venir como Array o como { items, ... }
      const items = Array.isArray(payload) ? payload : payload?.items || [];
      // normaliza a minimal
      const minimal = items
        .filter((x) => x && x.uniqd)
        .map((x) => ({
          uniqd: String(x.uniqd),
          quantity: Number(x.quantity || 1),
        }));
      console.log("minimal", minimal);
      // procesa SIEMPRE con minimal
      // await this.processCartSucursal(minimal);
    });

    // Pide snapshot a otros componentes
    this.emitter.emit("cart-list", {});

    // Términos
    this.emitter.on("acept-terminos", (data) => {
      this.acepte_terminos = data;
    });

    // Años tarjeta (tu lógica)
    let minYear = new Date().getFullYear() - 1;
    for (let i = 0; i <= 1; i++) {
      minYear = minYear + 1;
      this.year_propies.push({ value: minYear % 100, year: minYear });
    }
    let maxYear = new Date().getFullYear() + 1;
    for (let i = 1; i <= 5; i++) {
      maxYear = maxYear + 1;
      this.year_propies.push({ value: maxYear % 100, year: maxYear });
    }

    // Config general
    const resp = await myApi.post("ecommerce/config_all", {});
    // this.cuentas = resp.data.cuentas;
    this.cuentas = [
      {
  id: 3,
  n_cuenta: "5430037189",
  banco: "Banco Agricola",
  tipo_cuenta: "CC",
  description: null,
  state: 1,
  created_at: null,
  updated_at: null
}
    ]
    this.today = resp.data.today;
    this.next_name_day = resp.data.next_name_day;
    this.next_num_day = resp.data.next_num_day;
    this.next_name_two_day = resp.data.next_name_two_day;
    this.next_num_two_day = resp.data.next_num_two_day;
    this.next_num_month = resp.data.next_num_month;

    // checkout.js (evita cargarlo 2 veces)
    setTimeout(() => {
      if (
        !document.querySelector('script[src="../../assets/js/checkout.js"]')
      ) {
        const script2 = document.createElement("script");
        script2.src = "../../assets/js/checkout.js";
        document.body.appendChild(script2);
        script2.onload = () => {
          /* listo */
        };
      }
    }, 50);
  },
};
</script>
<style>
.collapcheckout:before {
  content: none !important;
}

.collapcheckout {
  color: white;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 15px;
  margin-top: 27px;
  background: #293152;
  border-radius: 20px;
}

.message-warning {
  background: #fedc327a !important;
  border-bottom: 3px solid #f7d00e7a !important;
}

.message-alert-checkout {
  padding: 12px 23px;
  margin-top: 2%;
}

/* .sucursales-flex2{
    display: flex;
    column-gap: 15px;
    justify-content: center;
    margin-top: 5%;
}
.sucursales-flex2 input[type=checkbox] {
    display: none;
}
.sucursales-checked img {
    border: 1px solid #4184F3 !important;
    border-radius: 25px !important;
    padding: 10px !important;
} */
<style scoped>
/* Estilos para las opciones de banco */
.bank-options {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: nowrap;
  gap: 15px;
  margin-top: 10px;
}

.bank-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 150px;
}

.bank-option img {
  height: 30px;
  width: auto;
  object-fit: contain;
  margin-bottom: 8px;
}

.bank-option span {
  text-align: center;
  font-size: 14px;
}

.bank-option.selected {
  border-color: #4caf50;
  background-color: rgba(76, 175, 80, 0.1);
  box-shadow: 0 0 5px rgba(76, 175, 80, 0.5);
}

.btn-sesion1 {
  display: flex;
  justify-content: center; /* horizontal */
  align-items: center; /* vertical   */
  min-height: 120px; /* ajusta según tu layout */
}

.wompi-info-alert {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  margin-bottom: 15px;
  padding: 15px 18px;
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-left: 4px solid #ff9800;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.1);
  animation: slideInDown 0.3s ease-out;
}

.wompi-info-alert .alert-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.wompi-info-alert .alert-icon svg {
  stroke: #ff6f00;
  width: 100%;
  height: 100%;
}

.wompi-info-alert .alert-content {
  flex: 1;
  color: #856404;
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
}

.wompi-info-alert .alert-content strong {
  color: #664d03;
  font-weight: 600;
}

@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dark-mode .wompi-info-alert {
  background-color: #3e3520;
  border-color: #ffa726;
  border-left-color: #ff9800;
}

.dark-mode .wompi-info-alert .alert-icon svg {
  stroke: #ffb74d;
}

.dark-mode .wompi-info-alert .alert-content {
  color: #ffd54f;
}

.dark-mode .wompi-info-alert .alert-content strong {
  color: #ffe082;
}

@media (max-width: 768px) {
  .wompi-info-alert {
    padding: 12px 14px;
    gap: 10px;
  }

  .wompi-info-alert .alert-content {
    font-size: 13px;
  }

  .wompi-info-alert .alert-icon {
    width: 20px;
    height: 20px;
  }
}

@media (max-width: 480px) {
  .wompi-info-alert {
    flex-direction: row;
    text-align: left;
  }
}
</style>
